/*
 * tp-explorer.js — Preis-Leistungs-Karte für Smartphones (Plan 0077, Variante E).
 * Abhaengigkeitsfreies IIFE, ES5. Kein Framework, keine Serverrunde je Regler-Zug.
 *
 * Ein Punkt = ein Angebot (Modell x Speicher x Zustand). X = Preis, Y = „Leistung"
 * 0..100 aus sechs Reglern (D7). Die gruene beste Linie ist die Pareto-Front: kein Punkt
 * ist zugleich billiger und besser (D8). Die Punkte stehen einmal im DOM und werden nur
 * verschoben.
 *
 * Daten: JSON nach Plan 0077 D5 (Preise in Cent), Adresse steht am Section-Element
 * (data-url) — Standard /apps/storefronthub/finder/v1/smartphone-offers.json. Die
 * Ausgabe steht im Pfad und noch einmal im JSON (Feld `v`, Plan 0088); welche der
 * Kunde gesehen hat, meldet jedes Tracking-Ereignis mit.
 * Farben (colors[] je Angebot, colors_all[] je Modell) sind optional: fehlen sie,
 * entfaellt der Farb-Chip und es werden keine Swatches gezeichnet.
 *
 * Der Rechenkern steht in tp-explorer-core.js und muss VOR dieser Datei geladen sein.
 */
(function () {
  'use strict';

  /* Rechenkern aus tp-explorer-core.js. Nur lesen — keine Stelle hier schreibt zurueck. */
  var C = window.TPExplorerCore;
  if (!C) { return; }
  var GI = C.GI, GLABEL = C.GLABEL, GCLASS = C.GCLASS, GSTEP = C.GSTEP;
  var GRADES = C.GRADES, WKEYS = C.WKEYS, WLABEL = C.WLABEL, PRESETS = C.PRESETS;
  var STOS = C.STOS, UPDS = C.UPDS, SCEN = C.SCEN, FAMLABEL = C.FAMLABEL;
  var BRANDS = C.BRANDS, BRANDLABEL = C.BRANDLABEL, FAMORDER = C.FAMORDER, FAMCOL = C.FAMCOL;
  var COLORNAME = C.COLORNAME, clamp01 = C.clamp01, famLabel = C.famLabel, brandKey = C.brandKey;
  var famSort = C.famSort, shortName = C.shortName, build = C.build, active = C.active;
  var wert = C.wert, pass = C.pass, score = C.score, pareto = C.pareto;
  var genLine = C.genLine, copyQ = C.copyQ, applyScen = C.applyScen, fineCount = C.fineCount;
  var hashOf = C.hashOf, parseHash = C.parseHash;

  /* ======================= Darstellung ======================= */

  var root = document.querySelector('[data-tp-explorer]');
  if (!root) { return; }

  var $ = function (sel) { return root.querySelector(sel); };
  /* Elementpuffer fuer den heissen Pfad. Ein Regler schickt bis zu 120 Ereignisse je
     Sekunde; ohne Puffer suchte paint() bei jedem davon dreissigmal durch den Baum.
     Was draw() neu baut, wird dort neu gepuffert — alles andere steht fest. */
  var E = {};
  function $e(sel) { return E[sel] || (E[sel] = root.querySelector(sel)); }
  function cacheEls() {
    E = {};
    ['[data-ex-plot]', '[data-ex-axes]', '[data-ex-fill]', '[data-ex-frontpath]', '[data-ex-frontlab]',
      '[data-ex-lines]', '[data-ex-labs]', '[data-ex-nums]', '[data-ex-dots]', '[data-ex-count]',
      '[data-ex-rings]', '[data-ex-hotr]', '[data-ex-gl]', '[data-ex-axt]',
      '[data-ex-poly]', '[data-ex-hit]', '[data-ex-glab]', '[data-ex-lead]', '[data-ex-elab]',
      '[data-ex-rail]', '[data-ex-delta]', '[data-ex-cards]', '[data-ex-alln]', '[data-ex-more]',
      '[data-ex-sort]'].forEach(function (sel) { E[sel] = root.querySelector(sel); });
  }
  /* Im lebenden Baum kostet JEDE Knotenaenderung — auch ein textContent — rund 50 ms,
     unabhaengig von der Groesse: fuenf fremde Skripte (darunter Shopify selbst und das
     Cookie-Banner) beobachten den body auf childList, und jede Einfuegung loest eine
     volle Stilneuberechnung der Seite aus. Attribute und nodeValue kosten dagegen
     nichts. Gemessen am Explorer: 50 ms gegen 0 ms je Bild.
     Deshalb wird im heissen Pfad jeder Knoten GENAU EINMAL angelegt und danach nur
     noch beschrieben — was gerade nicht gebraucht wird, steht auf display="none". */
  var SVGNS = 'http://www.w3.org/2000/svg';
  function pool(host, tag, cls, want, withText) {
    while (host.childElementCount < want) {
      var el = document.createElementNS(SVGNS, tag);
      el.setAttribute('class', cls);
      if (withText) { el.appendChild(document.createTextNode('')); }
      host.appendChild(el);
    }
    return host.children;
  }
  function show(el, on) {
    if (on) { el.removeAttribute('display'); } else { el.setAttribute('display', 'none'); }
  }
  function setText(el, t) {
    if (!el) { return; }
    if (!el.firstChild) { el.appendChild(document.createTextNode('')); }
    if (el.firstChild.nodeValue !== t) { el.firstChild.nodeValue = t; }
  }
  function hideRest(list, from) {
    for (var i = from; i < list.length; i++) { show(list[i], false); }
  }

  /* Gezeichnet wird hoechstens einmal je Bild. Alles, was ein Regler dazwischen meldet,
     wuerde der Browser ohnehin verwerfen — nur hat es vorher trotzdem gerechnet. */
  var paintRAF = 0, dragT = null;
  function repaint() {
    /* Waehrend am Regler gezogen wird, laeuft die Gleit-Animation der Punkte NICHT mit:
       sie startet sonst je Bild 327-mal neu, und der Browser animiert dann dauerhaft
       ein SVG mit tausend Knoten. Das war der eigentliche Bremsklotz — nicht das
       Rechnen, sondern das Nachziehen von Stil und Layout (siehe .is-drag im CSS).
       140 ms nach dem letzten Tick ist die Animation wieder an, fuer den Klick auf
       einen Chip gleiten die Punkte also weiterhin an ihren neuen Platz. */
    root.classList.add('is-drag');
    clearTimeout(dragT);
    dragT = setTimeout(function () { root.classList.remove('is-drag'); paint(); }, 140);
    if (paintRAF) { return; }
    paintRAF = requestAnimationFrame(function () { paintRAF = 0; paint(); });
  }
  /* Leerzustaende kommen als JSON aus der Section, damit sie im Theme-Editor stehen. */
  var T = { rail_empty: 'Auf der besten Linie ist gerade nichts lieferbar.',
    grid_empty: 'Kein Angebot passt zu diesen Filtern. Lockere einen Filter, dann wird die Karte wieder voll.' };
  try {
    var i18n = JSON.parse(root.querySelector('[data-ex-i18n]').textContent);
    Object.keys(T).forEach(function (k) { if (i18n[k]) { T[k] = i18n[k]; } });
  } catch (e) { /* Rueckfall oben steht */ }
  var PTS = [], DATA = null, DATAV = '', FAMS = [], BASES = [], DOTS = null, GEO = null;
  /* Zu jedem Punkt die beiden Kreise und der zuletzt geschriebene Stand. Ohne das rief
     paint() je Punkt zweimal querySelector und schrieb Attribute, die gleich blieben. */
  var DEL = [];
  var lastAxKey = '';
  var FAMSOF = {}, FAMBRAND = {}, BRANDSIN = [];
  /* Hoechstens acht Nummern — mehr Badges kann man auf der Karte nicht mehr lesen. */
  var MAX_LIST = Math.min(8, +(root.getAttribute('data-max') || 8));
  var CARD_V = root.getAttribute('data-cardv') || '';
  var MINV = +(root.getAttribute('data-minv') || 30);
  var GRID_STEP = 24, gridN = GRID_STEP, gridSort = 'vpp', gridT = null, IO = null;
  var PMIN = 0, PMAX = 1900, HAS_COLORS = false, NOW = new Date().getFullYear();
  var sel = null, cache = {}, cardId = {}, pending = {}, queue = [], inflight = 0, cardPt = {};
  var listKey = null, sheetState = null;
  /* Ausgangslage (Section-Einstellungen, NICHT der Hash): Bezug fuer „Szenario aus",
     „Filter lockern" und den Zaehler am Feinfilter-Klappbereich. */
  var DEF = null, DEFW = {}, scen = null, fineOpen = false;
  /* Tracking (D10): PRESET = zuletzt gewaehlte Voreinstellung (null, sobald von Hand
     geschoben), trkCause = was den letzten Neuzeichnen-Lauf ausgeloest hat. */
  var PRESET = null, DEFP = null, trkCause = null, trkEmpty0 = false, trkBudT = null, trkWT = null;
  var SORTS = [
    { k: 'vpp', l: 'Meiste Gesamtnote fürs Geld' }, { k: 'price', l: 'Günstigste zuerst' },
    { k: 'value', l: 'Stärkste zuerst' }, { k: 'new', l: 'Neueste Modelle' }
  ];
  var Q = { brand: null, fams: [], sto: 0, gr: 'C', pmin: 0, pmax: 1900, upd: 2, color: null, cond: null, now: NOW };
  var W = { cam: 50, batt: 50, chip: 50, recency: 50, updates: 50, storage: 50 };

  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function eur(cents) {
    var s = (cents / 100).toFixed(2).replace('.', ',');
    return s.replace(/\B(?=(\d{3})+(?!\d)(?=,))/g, '.') + ' €';
  }
  function stoLabel(st) { return st >= 1024 ? (st / 1024) + ' TB' : st + ' GB'; }
  function mob() { return window.matchMedia('(max-width:749px)').matches; }
  /* Phone-Schwelle: ab hier steht die Liste im Vordergrund, die Filter liegen im
     Bottom-Sheet. 641–749 px bleibt exakt die bisherige Darstellung. */
  function phone() { return window.matchMedia('(max-width:640px)').matches; }

  /* ---------- Farben ---------- */
  function swatch(base, title) {
    return '<i class="tp-ex__sw tp-ex__sw--' + esc(base || 'gray') + '"' +
      (title ? ' title="' + esc(title) + '"' : '') + ' aria-hidden="true"></i>';
  }
  function colorName(c) { return c.c || COLORNAME[c.base] || c.base || 'Farbe'; }
  /* ---------- Geometrie ---------- */
  function geo() {
    var plot = $('[data-ex-plot]');
    var cw = Math.max(280, plot.clientWidth || 720);
    if (!mob()) { return { w: cw, h: 430, x0: 54, x1: cw - 96, y0: 358, y1: 34, fs: 10.5, mob: 0, ph: 0 }; }
    /* Auf dem Phone ist die Karte kompakt (~55 % der Fensterhoehe): darunter soll ohne
       langes Wischen die Kaufliste stehen. Der Rahmen 320–480 px haelt sie auf kleinen
       Geraeten lesbar und auf grossen im Bild. */
    if (!phone()) { return { w: cw, h: 420, x0: 38, x1: cw - 74, y0: 350, y1: 34, fs: 9.5, mob: 1, ph: 0 }; }
    var h = Math.min(480, Math.max(320, Math.round(window.innerHeight * 0.55)));
    return { w: cw, h: h, x0: 38, x1: cw - 74, y0: h - 70, y1: 34, fs: 9.5, mob: 1, ph: 1 };
  }
  /* Sichtbarer Ausschnitt in Euro bzw. Punkten. Auf dem Desktop ist er fest
     (0..PMAX, 0..100), auf dem Phone folgt er den sichtbaren Punkten — siehe domain(). */
  var VX0 = 0, VX1 = 1900, VY0 = 0, VY1 = 100;
  function X(cents) { return GEO.x0 + (GEO.x1 - GEO.x0) * clamp01((cents / 100 - VX0) / (VX1 - VX0)); }
  function Y(v) { return GEO.y0 + (GEO.y1 - GEO.y0) * clamp01((v - VY0) / (VY1 - VY0)); }
  function R(p) { return p.pq > 0 ? 3.4 + Math.min(5.4, p.pq * 0.62) : 3.4; }
  /* Auf dem Phone ist ein Punkt nur dann da, wenn er auch gezeichnet wird: die
     ausgefilterten und die abgelaufenen sind dort ganz weg (CSS), also duerfen sie
     weder den Ausschnitt aufspannen noch den Treffer-Umkreis gewinnen. */
  function shown(p) { return p.ok && !(GEO.ph && p.exp); }
  /* Runde Obergrenze fuer die Preisachse: der kleinste Schritt, der den hoechsten
     sichtbaren Preis in hoechstens acht Stufen fasst (50 bis 400 €, 100 bis 800 €,
     sonst 250). Grob runden verschenkt sonst ein Drittel der Breite. */
  function roundUp(hi) {
    var cand = [50, 100, 250, 500], i;
    for (i = 0; i < cand.length; i++) { if (hi / cand[i] <= 8) { return Math.max(cand[i], Math.ceil(hi / cand[i]) * cand[i]); } }
    return Math.ceil(hi / 500) * 500;
  }
  /* Auf dem Phone an die sichtbaren Punkte heranfahren: sonst klebt die ganze Wolke
     im linken oberen Viertel, weil die Achse bis zum teuersten Angebot des Katalogs
     laeuft und die Notenachse bei 0 anfaengt. */
  function domain(vis) {
    VX0 = PMIN; VX1 = PMAX; VY0 = 0; VY1 = 100;
    if (!GEO.ph || !vis.length) { return; }
    var hi = 0, lo = 100, i;
    for (i = 0; i < vis.length; i++) {
      if (vis[i].px / 100 > hi) { hi = vis[i].px / 100; }
      if (vis[i].v < lo) { lo = vis[i].v; }
    }
    VX1 = Math.min(PMAX, roundUp(hi));
    VY0 = Math.max(0, Math.min(90, Math.floor(lo / 10) * 10));
  }

  function ticks() {
    var cand = [50, 100, 200, 250, 400, 500, 1000], span = VX1 - VX0, step = 1000, i;
    var want = mob() ? 4 : 5;
    for (i = 0; i < cand.length; i++) { if (span / cand[i] <= want) { step = cand[i]; break; } }
    var out = [];
    for (var v = Math.ceil(VX0 / step) * step; v <= VX1; v += step) { out.push(v); }
    return out;
  }
  /* Drei Marken auf dem Phone (der Ausschnitt startet nicht mehr bei 0), fuenf sonst. */
  function yTicks() {
    return GEO.ph ? [VY0, Math.round((VY0 + 100) / 2), 100] : [0, 25, 50, 75, 100];
  }
  /* Achsen und Raster haengen am Ausschnitt und der aendert sich auf dem Phone mit
     jedem Filter — deshalb bei jedem paint() neu statt einmal beim Zeichnen. */
  function axes() {
    /* Auf dem Desktop steht der Ausschnitt fest — dann ist das Raster nach dem ersten
       Lauf fertig und muss nicht bei jedem Regler-Tick neu geschrieben werden. */
    var key = VX0 + '|' + VX1 + '|' + VY0 + '|' + VY1 + '|' + GEO.w + '|' + GEO.h;
    if (key === lastAxKey) { return; }
    lastAxKey = key;
    var g = GEO, xs = ticks(), ys = yTicks(), i, el;
    var gl = pool($e('[data-ex-gl]'), 'line', 'tp-ex__gl', xs.length + ys.length);
    var tx = pool($e('[data-ex-axt]'), 'text', 'tp-ex__ax', xs.length + ys.length, true);
    for (i = 0; i < xs.length; i++) {
      el = gl[i];
      el.setAttribute('x1', X(xs[i] * 100)); el.setAttribute('y1', g.y1);
      el.setAttribute('x2', X(xs[i] * 100)); el.setAttribute('y2', g.y0);
      show(el, true);
      el = tx[i];
      el.setAttribute('x', X(xs[i] * 100)); el.setAttribute('y', g.y0 + 18);
      el.setAttribute('text-anchor', 'middle');
      setText(el, xs[i] + ' \u20ac');
      show(el, true);
    }
    for (i = 0; i < ys.length; i++) {
      el = gl[xs.length + i];
      el.setAttribute('x1', g.x0); el.setAttribute('y1', Y(ys[i]));
      el.setAttribute('x2', g.x1); el.setAttribute('y2', Y(ys[i]));
      show(el, true);
      el = tx[xs.length + i];
      el.setAttribute('x', g.x0 - 8); el.setAttribute('y', Y(ys[i]) + 3.5);
      el.setAttribute('text-anchor', 'end');
      setText(el, String(ys[i]));
      show(el, true);
    }
    hideRest(gl, xs.length + ys.length);
    hideRest(tx, xs.length + ys.length);
  }

  /* ---------- Geruest ---------- */
  function draw() {
    GEO = geo();
    var g = GEO, h = '', i;
    /* Raster und Achsenbeschriftung fuellt axes() bei jedem paint() — der Ausschnitt
       kann sich aendern, ohne dass das ganze SVG neu gebaut wird. */
    h += '<g data-ex-axes><g data-ex-gl></g><g data-ex-axt></g></g>';
    /* Die senkrechte Achsenbeschriftung steht als HTML neben dem SVG (data-ex-ytit) —
       nur so haengt der Info-Punkt an einem echten Button mit Popover und Tastaturfokus. */
    h += '<text class="tp-ex__axt" x="' + g.x1 + '" y="' + (g.y0 + 34) + '" text-anchor="end">Preis in €</text>'
      + '<path class="tp-ex__fill" data-ex-fill/><path class="tp-ex__front" data-ex-frontpath/>'
      + '<text class="tp-ex__frontlab" data-ex-frontlab text-anchor="end"></text>'
      + '<g data-ex-lines><g data-ex-poly></g><g data-ex-hit></g></g>'
      + '<g data-ex-labs><g data-ex-glab></g><g data-ex-lead></g><g data-ex-elab></g></g>'
      /* Die gruenen Ringe der besten Linie und der pulsierende Ring unter dem Zeiger
         stehen als eigene, kurze Gruppe da — frueher hing an JEDEM der 330 Punkte ein
         zweiter, unsichtbarer Kreis, der bei jedem Bild mitvermessen wurde. */
      + '<g data-ex-rings></g><circle class="tp-ex__hotr" data-ex-hotr r="0" display="none"/>'
      + '<g data-ex-dots>';
    for (i = 0; i < PTS.length; i++) {
      var p = PTS[i];
      /* Ein Kreis, bewegt ueber cx/cy. Mit <g transform> kostete dasselbe Bild das
         Fuenffache: das transform-Attribut zwingt den Browser, das ganze SVG neu zu
         vermessen (gemessen 92 ms gegen 18 ms je Bild auf einem Mittelklasse-Phone). */
      h += '<circle class="tp-ex__pt ' + GCLASS[p.gr] + '" data-i="' + i + '" tabindex="0" role="button"'
        + ' cx="0" cy="0" r="' + R(p) + '"'
        + ' aria-label="' + esc(p.m.name + ' ' + stoLabel(p.st) + ', ' + GLABEL[p.gr]) + '"/>';
    }
    h += '</g><g data-ex-nums></g>';
    $('[data-ex-plot]').innerHTML = '<svg viewBox="0 0 ' + g.w + ' ' + g.h + '" preserveAspectRatio="xMidYMid meet"'
      + ' role="img" aria-label="Preis gegen Gesamtnote, ein Punkt je Angebot">' + h + '</svg>';
    cacheEls();
    DOTS = E['[data-ex-plot]'].querySelectorAll('.tp-ex__pt');
    DEL = [];
    for (i = 0; i < DOTS.length; i++) {
      DEL.push({ g: DOTS[i], r: R(PTS[i]), x: '', y: '', cls: '', front: 0 });
    }
    /* Alles im SVG ist frisch — die Vergleichsstaende von eben gelten nicht mehr. */
    lastAxKey = '';
    countEls = null;
    deltaEls = null;
    paint();
  }

  /* Labels senkrecht auseinanderschieben, damit sich nichts ueberlappt. */
  function spread(items, gap, lo, hi) {
    items.sort(function (a, b) { return a.y - b.y; });
    var i;
    for (i = 1; i < items.length; i++) { if (items[i].y - items[i - 1].y < gap) { items[i].y = items[i - 1].y + gap; } }
    for (i = items.length - 2; i >= 0; i--) { if (items[i + 1].y - items[i].y < gap) { items[i].y = items[i + 1].y - gap; } }
    var shift = 0, last = items[items.length - 1];
    if (last && last.y > hi) { shift = hi - last.y; }
    if (items[0] && items[0].y + shift < lo) { shift = lo - items[0].y; }
    for (i = 0; i < items.length; i++) { items[i].y += shift; }
    return items;
  }

  /* Knoten-Tags der Leiter PLATZIEREN (lx/ly/hide je Knoten). Greedy versetzt: erst
     ueber den Punkt, dann darunter, dann weiter weg — der erste freie Platz gewinnt.
     Findet sich keiner, bleibt der Knoten ohne Tag (hide): lieber kein Name als
     Buchstabensalat. Markup macht drawLadder() daraus — getrennt, damit beim Ziehen
     nur noch Koordinaten wandern statt eines neuen SVG-Bruchstuecks. */
  function nodeLabs(nodes) {
    var OFF = [[0, -10], [0, 15], [0, -24], [0, 29], [-18, -10], [18, -10], [-18, 15], [18, 15], [0, -38], [0, 43]];
    var put = [];
    nodes.forEach(function (l) {
      var k, free = false;
      for (k = 0; k < OFF.length; k++) {
        l.lx = l.x + OFF[k][0]; l.ly = l.y + OFF[k][1];
        free = put.every(function (q) {
          return Math.abs(q.lx - l.lx) > (q.w + l.w) / 2 + 4 || Math.abs(q.ly - l.ly) > GEO.fs + 4;
        });
        if (free) { break; }
      }
      l.hide = !free;
      if (free) { put.push(l); }
    });
    return nodes;
  }

  /* Leitern, Knoten-Tags und die Baureihen-Namen am rechten Rand ins SVG bringen.
     Alles ueber Attribute und nodeValue in einen festen Knotenvorrat (siehe pool()):
     das Neubauen dieser beiden Gruppen war mit Abstand der teuerste Posten des
     Neuzeichnens, teurer als alle 330 Punkte zusammen. Jetzt kostet es nichts, und
     die Leitern folgen den Punkten wieder bei JEDEM Bild statt alle 60 ms. */
  function drawLadder(segs, nodes, labs) {
    var i, k, el, sg, want = 0;

    var poly = pool($e('[data-ex-poly]'), 'polyline', 'tp-ex__line', segs.length);
    for (i = 0; i < segs.length; i++) {
      sg = segs[i]; el = poly[i];
      el.setAttribute('points', sg.pts.map(function (p) { return X(p.px).toFixed(1) + ',' + Y(p.v).toFixed(1); }).join(' '));
      el.setAttribute('stroke', sg.col);
      el.setAttribute('data-f', sg.fam);
      show(el, true);
    }
    hideRest(poly, segs.length);

    /* Je Abschnitt eine eigene, dicke Trefferlinie — nur so kann der Tooltip sagen, was
       der Schritt von einer Generation zur naechsten kostet. Auf dem Phone gibt es kein
       Schweben und damit keinen Tooltip: dort bleiben sie ganz weg. */
    if (!GEO.mob) { for (i = 0; i < segs.length; i++) { want += segs[i].pts.length - 1; } }
    var hits = pool($e('[data-ex-hit]'), 'line', 'tp-ex__hit', want);
    k = 0;
    if (!GEO.mob) {
      for (i = 0; i < segs.length; i++) {
        sg = segs[i];
        for (var j = 1; j < sg.pts.length; j++) {
          el = hits[k++];
          el.setAttribute('data-f', sg.fam);
          el.setAttribute('data-a', sg.pts[j - 1].i);
          el.setAttribute('data-b', sg.pts[j].i);
          el.setAttribute('x1', X(sg.pts[j - 1].px).toFixed(1));
          el.setAttribute('y1', Y(sg.pts[j - 1].v).toFixed(1));
          el.setAttribute('x2', X(sg.pts[j].px).toFixed(1));
          el.setAttribute('y2', Y(sg.pts[j].v).toFixed(1));
          show(el, true);
        }
      }
    }
    hideRest(hits, k);

    var gl = pool($e('[data-ex-glab]'), 'text', 'tp-ex__glab', nodes.length, true);
    for (i = 0; i < nodes.length; i++) {
      el = gl[i];
      el.setAttribute('x', nodes[i].lx.toFixed(1));
      el.setAttribute('y', nodes[i].ly.toFixed(1));
      el.setAttribute('fill', nodes[i].col);
      el.setAttribute('text-anchor', 'middle');
      el.setAttribute('style', 'font-size:' + (GEO.fs - 0.5) + 'px');
      setText(el, nodes[i].t);
      show(el, !nodes[i].hide);
    }
    hideRest(gl, nodes.length);

    /* Rechts bleiben nur ~96 px (Desktop) bzw. ~74 px (mobil) fuer die Beschriftung. */
    var maxLen = GEO.mob ? 13 : 16;
    var lead = pool($e('[data-ex-lead]'), 'line', 'tp-ex__lead', labs.length);
    var elab = pool($e('[data-ex-elab]'), 'text', 'tp-ex__elab', labs.length, true);
    for (i = 0; i < labs.length; i++) {
      var l = labs[i], lx = Math.max(l.px + 10, GEO.x1 + 8), t = famLabel(l.fam);
      if (t.length > maxLen) { t = t.slice(0, maxLen - 1) + '\u2026'; }
      el = lead[i];
      el.setAttribute('x1', (l.px + 4).toFixed(1));
      el.setAttribute('y1', l.py.toFixed(1));
      el.setAttribute('x2', (lx - 3).toFixed(1));
      el.setAttribute('y2', l.y.toFixed(1));
      el.setAttribute('stroke', l.col);
      show(el, Math.abs(l.y - l.py) > 1.5 || lx - l.px > 14);
      el = elab[i];
      el.setAttribute('x', lx);
      el.setAttribute('y', l.y.toFixed(1));
      el.setAttribute('fill', l.col);
      el.setAttribute('style', 'font-size:' + GEO.fs + 'px');
      setText(el, t);
      show(el, true);
    }
    hideRest(lead, labs.length);
    hideRest(elab, labs.length);
  }

  function paint() {
    var okPts = [], vis = [], i, p, dd, cls, cx, cy, r;
    /* Erst Wert und Filter fuer alle — daraus ergibt sich der Ausschnitt, und erst
       danach stehen die Punkte an ihrem Platz. Geschrieben wird nur, was sich auch
       geaendert hat: ein Regler-Tick ruehrt sonst 1.600 Klassen ohne Wirkung an. */
    score(PTS, W);
    for (i = 0; i < PTS.length; i++) {
      p = PTS[i]; dd = DEL[i];
      p.ok = pass(p, Q);
      cls = (p.ok ? '' : 'o') + (p.pq <= 0 ? 'l' : '') + (p.exp ? 'x' : '');
      if (dd.cls !== cls) {
        dd.cls = cls;
        dd.g.classList.toggle('is-off', !p.ok);
        dd.g.classList.toggle('is-out', p.pq <= 0);
        dd.g.classList.toggle('is-exp', !!p.exp);
      }
      if (dd.front) { dd.front = 0; dd.g.classList.remove('is-front'); }
      if (p.ok) { okPts.push(p); }
      if (shown(p)) { vis.push(p); }
    }
    domain(vis);
    axes();
    for (i = 0; i < PTS.length; i++) {
      p = PTS[i]; dd = DEL[i];
      cx = X(p.px).toFixed(1); cy = Y(p.v).toFixed(1);
      if (dd.x !== cx) { dd.x = cx; dd.g.setAttribute('cx', cx); }
      if (dd.y !== cy) { dd.y = cy; dd.g.setAttribute('cy', cy); }
      r = R(p);
      if (dd.r !== r) { dd.r = r; dd.g.setAttribute('r', r); }
    }

    var front = pareto(okPts, MINV);
    for (i = 0; i < front.length; i++) { DEL[front[i].i].front = 1; DOTS[front[i].i].classList.add('is-front'); }
    /* Ringe: ein Kreis je Punkt auf der besten Linie, also rund zehn statt dreihundert. */
    var rings = pool($e('[data-ex-rings]'), 'circle', 'tp-ex__fr', front.length);
    for (i = 0; i < front.length; i++) {
      rings[i].setAttribute('cx', X(front[i].px).toFixed(1));
      rings[i].setAttribute('cy', Y(front[i].v).toFixed(1));
      rings[i].setAttribute('r', R(front[i]) + 3.6);
      show(rings[i], true);
    }
    hideRest(rings, front.length);
    var d = front.map(function (p, k) { return (k ? 'L' : 'M') + X(p.px).toFixed(1) + ' ' + Y(p.v).toFixed(1); }).join(' ');
    $e('[data-ex-frontpath]').setAttribute('d', d);
    $e('[data-ex-fill]').setAttribute('d', front.length > 1
      ? d + ' L ' + X(front[front.length - 1].px).toFixed(1) + ' ' + GEO.y0 + ' L ' + X(front[0].px).toFixed(1) + ' ' + GEO.y0 + ' Z'
      : '');
    var fl = $e('[data-ex-frontlab]');
    fl.setAttribute('x', GEO.x1); fl.setAttribute('y', GEO.y0 - 10);
    fl.setAttribute('style', 'font-size:' + GEO.fs + 'px');
    setText(fl, front.length > 1
      ? (GEO.mob ? '↑ Mehr geht fürs Geld nicht' : '↑ Über dieser Linie gibt es nichts fürs Geld') : '');

    /* Generationsleiter: bei gewaehlter Marke deren Familien, sonst nur die vier mit den
       meisten passenden Punkten — mehr Linien sind Spaghetti. */
    var count = {}, segs = [], labs = [], nodes = [];
    for (i = 0; i < okPts.length; i++) { count[okPts[i].m.family] = (count[okPts[i].m.family] || 0) + 1; }
    /* „Sonstige" ist keine Baureihe, sondern ein Sammelbecken — eine Linie von einem
       Redmi ueber ein XCover zu einem moto behauptet eine Generationenfolge, die es
       nicht gibt. Deshalb nie eine Leiter darueber. */
    var famList = Object.keys(count).filter(function (f) { return f !== 'sonstige'; });
    famList = Q.brand
      ? famList.sort(famSort)
      : famList.sort(function (a, b) { return count[b] - count[a]; }).slice(0, 4);
    famList.forEach(function (fam) {
      var pts = genLine(okPts, fam);
      if (pts.length < 2) { return; }
      var col = FAMCOL[FAMS.indexOf(fam) % FAMCOL.length];
      segs.push({ fam: fam, col: col, pts: pts });
      pts.forEach(function (p, k) {
        /* Lange Leitern nur jeden zweiten Knoten beschriften (Endpunkte immer). */
        if (pts.length > 10 && k % 2 && k !== pts.length - 1) { return; }
        var t = shortName(p.m);
        nodes.push({ x: X(p.px), y: Y(p.v), t: t, col: col, w: t.length * GEO.fs * 0.58 });
      });
      var last = pts[pts.length - 1];
      labs.push({ fam: fam, col: col, px: X(last.px), py: Y(last.v), y: Y(last.v) });
    });
    if (GEO.ph) {
      /* Auf dem Phone weder Knoten-Tags („13 mini", „A15") noch verschobene Labels —
         die lagen uebereinander. Es bleiben die Familien am rechten Rand, und von
         zwei kollidierenden faellt die kleinere weg (famList ist nach Anzahl sortiert). */
      var kept = [];
      labs = labs.filter(function (l) {
        var free = kept.every(function (q) { return Math.abs(q.y - l.y) > GEO.fs + 4; });
        if (free) { kept.push(l); }
        return free;
      });
      nodes = [];
    } else {
      spread(labs, GEO.fs + 3.5, GEO.y1 + 4, GEO.y0 - 4);
      nodeLabs(nodes);
    }
    drawLadder(segs, nodes, labs);

    if (!countEls) { buildCount(); }
    setText(countEls.a, String(okPts.length));
    setText(countEls.b, String(front.length));
    countEls.sp.classList.toggle('is-off', !front.length);
    lastOk = okPts;
    paintRail(front);
    paintDelta(front);
    /* Leerzustand einmal melden — nicht bei jedem Regler-Tick, solange er anhaelt. */
    if (!okPts.length) {
      if (trkCause && !trkEmpty0) { trk('explorer_empty', trkCause); trkEmpty0 = true; }
    } else { trkEmpty0 = false; }
    clearTimeout(gridT);
    gridT = setTimeout(paintGrid, 250);
  }

  /* Die Zaehlzeile wird EINMAL gebaut, danach wandern nur noch Ziffern in die
     vorhandenen Textknoten — ein neues innerHTML kostete hier 50 ms je Bild. */
  var countEls = null;
  function buildCount() {
    var el = $e('[data-ex-count]'), b1 = document.createElement('b'), b2 = document.createElement('b');
    var sp = document.createElement('span');
    b1.appendChild(document.createTextNode('0'));
    b2.appendChild(document.createTextNode('0'));
    sp.appendChild(b2);
    sp.appendChild(document.createTextNode(' liegen auf der besten Linie'));
    while (el.firstChild) { el.removeChild(el.firstChild); }
    el.appendChild(b1);
    el.appendChild(document.createTextNode(' von ' + PTS.length + ' Angeboten passen'));
    el.appendChild(sp);
    countEls = { a: b1, b: b2, sp: sp };
  }

  /* ---------- Kaufliste ---------- */
  function secInfo(m) {
    var left = m.security_until - NOW, span = Math.max(1, m.security_until - m.release_year);
    return {
      left: left,
      w: Math.max(4, Math.round(Math.max(0, left) / span * 100)),
      cls: left >= 3 ? 'is-long' : (left === 2 ? 'is-mid' : (left === 1 ? 'is-short' : 'is-end')),
      txt: left <= 0 ? 'läuft dieses Jahr aus' : (left === 1 ? 'noch 1 Jahr' : 'noch ' + left + ' Jahre')
    };
  }
  /* Rueckfall, wenn die Section-API die Karte nicht liefert (404, Produkt weg, Netz). */
  function miniCard(p) {
    var a = p.act || { h: p.h, img: p.img, price: p.price };
    return '<a class="tp-pc tp-ex__mini ' + GCLASS[p.gr] + '" href="/products/' + encodeURIComponent(a.h) + '">'
      + '<div class="tp-pc__ph">' + (a.img || p.img ? '<img class="tp-pc__img" src="' + esc(a.img || p.img) + '" alt="" loading="lazy">' : '') + '</div>'
      + '<div class="tp-pc__meta"><div class="tp-pc__row"><span class="tp-pc__brand">' + esc(p.m.brand) + '</span>'
      + '<span class="tp-cond tp-cond--steps ' + GCLASS[p.gr] + ' is-' + GSTEP[p.gr] + '">'
      + '<span class="tp-cond__steps" aria-hidden="true"><i></i><i></i><i></i><i></i></span>'
      + '<span class="tp-cond__name">' + GLABEL[p.gr] + '</span></span></div>'
      + '<h3 class="tp-pc__title">' + esc(p.m.name + ' · ' + stoLabel(p.st)) + '</h3>'
      + '<div class="tp-pc__price"><span class="tp-pc__now">' + eur(a.price) + '</span></div></div></a>';
  }
  function updLine(m) {
    return m.security_until < NOW ? 'Keine Sicherheitsupdates mehr (seit ' + m.security_until + ')' : 'Updates bis ' + m.security_until;
  }
  /* Die echte Produktkarte per Section-Rendering-API (D9). Muster wie tp-likes.js:
     ein <article> ausserhalb seines Wrappers ueberlebt den Parser nur im <template>.
     Hoechstens sechs Anfragen gleichzeitig, der Rest wartet in der Schlange — beim
     Grid mit 24+ Karten waere sonst der Shop-Server die Bremse. */
  function fetchCard(handle) {
    if (cache[handle] !== undefined || pending[handle]) { return; }
    if (inflight >= 6) { if (queue.indexOf(handle) < 0) { queue.push(handle); } return; }
    pending[handle] = 1; inflight++;
    fetch('/products/' + encodeURIComponent(handle) + '?section_id=tp-explorer-card' + CARD_V, { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var t = document.createElement('template');
        t.innerHTML = html || '';
        var el = t.content.querySelector('[data-tp-ex-card]');
        cache[handle] = el ? el.innerHTML : null;
        /* Die Produkt-ID kommt nur aus der Section-Antwort — ohne sie kein Merken-Herz. */
        if (el) { cardId[handle] = el.getAttribute('data-product-id'); }
      })
      .catch(function () { cache[handle] = null; })
      .then(function () {
        delete pending[handle]; inflight--;
        fillCards(handle);
        /* Sheet offen und es ging um genau dieses Produkt: neu zeichnen, damit das
           Merken-Herz erscheint (es haengt an der eben eingetroffenen Produkt-ID). */
        if (sheetState && hOf(sheetState) === handle) { renderSheet(sheetState); }
        var next = queue.shift();
        if (next) { fetchCard(next); }
      });
  }
  /* Nachtraeglich eingetroffene Karte in alle Platzhalter mit diesem Handle setzen. */
  function fillCards(handle) {
    var sel = '[data-ch="' + handle.replace(/["\\]/g, '') + '"]';
    var slots = [].slice.call(root.querySelectorAll(sel)), i;
    /* Auch die geparkten Karten fuellen: Rail und Grid halten fertige Knoten zum
       Wiederverwenden, die gerade nicht im Baum haengen. Ohne das behielte so eine
       Karte ihr Skelett fuer immer — sie wird nie wieder neu gebaut. */
    [rcEl, gcEl].forEach(function (map) {
      Object.keys(map).forEach(function (k) {
        var slot = map[k].isConnected ? null : map[k].querySelector(sel);
        if (slot) { slots.push(slot); }
      });
    });
    for (i = 0; i < slots.length; i++) {
      slots[i].innerHTML = cache[handle] || (cardPt[handle] ? miniCard(cardPt[handle]) : '');
    }
  }

  var lastFront = [], lastOk = [], lastNums = [];
  function hOf(p) { return (p.act && p.act.h) || p.h; }
  /* Die nummerierten Punkte der besten Linie: hoechstens MAX_LIST, gleichmaessig ueber die
     PREISSPANNE verteilt (nicht die N billigsten — die haengen alle in derselben Ecke).
     Der guenstigste und der beste Punkt sind immer dabei, Reihenfolge nach Preis. */
  function pickNums(front) {
    var lief = front.filter(function (p) { return p.pq > 0; }).sort(function (a, b) { return a.px - b.px; });
    if (lief.length <= MAX_LIST) { return lief; }
    var lo = lief[0].px, hi = lief[lief.length - 1].px, taken = {}, out = [], k;
    for (k = 0; k < MAX_LIST; k++) {
      var want = lo + (hi - lo) * k / (MAX_LIST - 1), best = null;
      lief.forEach(function (p) {
        if (taken[p.i]) { return; }
        if (!best || Math.abs(p.px - want) < Math.abs(best.px - want)) { best = p; }
      });
      if (best) { taken[best.i] = 1; out.push(best); }
    }
    return out.sort(function (a, b) { return a.px - b.px; });
  }
  function ringHTML(v) {
    var r = Math.round(v);
    return '<span class="tp-ex__ring" data-v="' + r + '" style="--p:' + r + '" title="Gesamtnote ' + r + ' von 100">'
      + '<b>' + r + '</b></span>';
  }
  /* Die Kaufliste zeigt dieselbe echte Produktkarte wie das Grid darunter (Section-
     Rendering-API). Vorher stand hier Eigenbau aus Bild, Titel und Preis — damit fehlten
     der Kaufliste Energielabel, Produktdatenblatt und Merken-Herz, obwohl das Grid
     zehn Zentimeter tiefer alles hatte. Der Explorer legt nur noch drumherum: Nummer,
     Notenring und die Update-Leiste. */
  function railCard(p, k) {
    var s = secInfo(p.m), h = hOf(p), card = cache[h];
    cardPt[h] = p;
    /* Der Fuss ist der Weg ins Detail-Sheet und sagt das jetzt auch: Zeile „Alle Preise
       und Details" mit Pfeil. Die Update-Leiste steckt IM Fuss statt an der Unterkante —
       dort schnitt die Eckenrundung der Karte sie schief ab. */
    return '<article class="tp-ex__rc" data-i="' + p.i + '" data-n="' + k + '" role="listitem">'
      + '<span class="tp-ex__rnum" aria-hidden="true">' + (k + 1) + '</span>'
      + '<div class="tp-ex__buycard" data-ch="' + esc(h) + '">'
      + (card === undefined ? '<div class="tp-ex__skel"></div>' : (card || miniCard(p))) + '</div>'
      + '<button type="button" class="tp-ex__rfoot" data-ex-open-i="' + p.i + '"'
      + ' aria-label="Alle Preise und Details zu ' + esc(p.m.name + ' ' + stoLabel(p.st) + ', ' + GLABEL[p.gr]) + '">'
      + '<span class="tp-ex__bar ' + s.cls + '"><i style="width:' + s.w + '%"></i></span>'
      + '<span class="tp-ex__rupd">' + updLine(p.m) + '</span>'
      + ringHTML(p.v)
      + '<span class="tp-ex__rmore">Preise &amp; Details</span></button></article>';
  }
  /* Fertige Kaufliste-Karten je Angebot. Genau wie im Grid werden die Knoten beim
     Umsortieren verschoben statt neu geschrieben: eine echte Produktkarte ist viel
     Markup, und beim Ziehen am Regler wechselt die beste Linie staendig. Neu gebaut
     wurde dabei achtmal je Bild — das war das Flackern der Bilder. */
  var rcEl = {};
  function rcKey(p) { return p.i + '|' + hOf(p); }
  /* Nummer und Notenring einer stehenden Karte nachziehen — nur ueber Attribute
     und nodeValue, nie ueber textContent (siehe pool()-Kommentar: 50 ms je Bild). */
  function tuneRail(el, p, k) {
    var num = el.children[0], ring = el.querySelector('.tp-ex__ring'), v = Math.round(p.v);
    if (el.getAttribute('data-n') != k) {
      el.setAttribute('data-n', k);
      if (num.firstChild) { num.firstChild.nodeValue = k + 1; }
    }
    if (!ring || +ring.getAttribute('data-v') === v) { return; }
    ring.setAttribute('data-v', v);
    ring.style.setProperty('--p', v);
    ring.title = 'Gesamtnote ' + v + ' von 100';
    if (ring.firstChild.firstChild) { ring.firstChild.firstChild.nodeValue = v; }
  }
  function paintRail(front) {
    lastFront = front;
    var nums = pickNums(front), i, gs;
    lastNums = nums;
    /* Nummern-Badges auf der Karte, gleiche Reihenfolge wie die Rail. Solange dieselben
       Angebote nummeriert sind, wandern die vorhandenen Marken mit — neu gebaut wird
       nur, wenn sich die Auswahl aendert. */
    var ng = $e('[data-ex-nums]');
    while (ng.childElementCount < nums.length) {
      var g = document.createElementNS(SVGNS, 'g');
      g.setAttribute('class', 'tp-ex__num');
      g.setAttribute('data-n', ng.childElementCount);
      var c = document.createElementNS(SVGNS, 'circle');
      c.setAttribute('r', 8);
      var tt = document.createElementNS(SVGNS, 'text');
      tt.setAttribute('y', 3.2);
      tt.setAttribute('text-anchor', 'middle');
      tt.appendChild(document.createTextNode(String(ng.childElementCount + 1)));
      g.appendChild(c); g.appendChild(tt);
      ng.appendChild(g);
    }
    gs = ng.children;
    for (i = 0; i < nums.length; i++) {
      gs[i].setAttribute('transform', 'translate(' + X(nums[i].px).toFixed(1) + ',' + (Y(nums[i].v) - 13).toFixed(1) + ')');
      show(gs[i], true);
    }
    hideRest(gs, nums.length);

    var box = $e('[data-ex-rail]');
    if (!nums.length) {
      if (listKey === '') { return; }
      listKey = '';
      box.innerHTML = '<p class="tp-ex__empty">' + esc(T.rail_empty)
        + ' <button type="button" class="tp-ex__more" data-ex-loose>Filter lockern</button></p>';
      return;
    }
    /* Stehen dieselben Angebote in derselben Reihenfolge da, wird nichts angefasst —
       nur die Notenringe zaehlen nach. Und waehrend am Regler gezogen wird, bleibt
       die Liste ueberhaupt stehen: acht Produktkarten umzuhaengen kostet 50 ms, und
       eine Liste, die je Bild neu springt, kann sowieso niemand lesen. Nach dem letzten
       Tick zeichnet der Zeitgeber aus repaint() sie sauber nach. */
    var key = nums.map(rcKey).join(',');
    if (key === listKey || (listKey !== null && root.classList.contains('is-drag'))) {
      for (i = 0; i < nums.length && i < box.childElementCount; i++) {
        tuneRail(box.children[i], nums[i], i);
      }
      return;
    }
    listKey = key;
    if (Object.keys(rcEl).length > 200) { rcEl = {}; }
    var frag = document.createDocumentFragment(), el, rk;
    for (i = 0; i < nums.length; i++) {
      rk = rcKey(nums[i]);
      el = rcEl[rk];
      if (!el) {
        if (cache[hOf(nums[i])] === undefined) { fetchCard(hOf(nums[i])); }
        var t = document.createElement('div');
        t.innerHTML = railCard(nums[i], i);
        el = rcEl[rk] = t.firstChild;
      } else {
        tuneRail(el, nums[i], i);
      }
      frag.appendChild(el);
    }
    while (box.firstChild) { box.removeChild(box.firstChild); }
    box.appendChild(frag);
  }
  /* Punkt und Rail-Karte zeigen aufeinander: beide bekommen is-hot. */
  function hot(i, on, scroll) {
    var el = root.querySelector('.tp-ex__rc[data-i="' + i + '"]');
    if (el) { el.classList.toggle('is-hot', on); }
    /* Der pulsierende Ring ist ein einziger Kreis, der zum Punkt wandert. */
    var hr = $e('[data-ex-hotr]');
    if (hr && DEL[i]) {
      if (on) {
        hr.setAttribute('cx', DEL[i].x); hr.setAttribute('cy', DEL[i].y);
        hr.setAttribute('r', DEL[i].r + 3.6);
        hr.removeAttribute('display');
      } else { hr.setAttribute('display', 'none'); }
    }
    if (el) {
      var n = root.querySelector('.tp-ex__num[data-n="' + el.getAttribute('data-n') + '"]');
      if (n) { n.classList.toggle('is-hot', on); }
    }
    /* Nur vom Punkt aus scrollen — sonst zoege die Rail unter dem Mauszeiger weg. */
    if (on && el && scroll) {
      var rail = $('[data-ex-rail]');
      rail.scrollTo({ left: Math.max(0, el.offsetLeft - (rail.clientWidth - el.offsetWidth) / 2), behavior: 'smooth' });
    }
  }

  /* Ohne Auswahl zeigt die Zeile den Einstieg: das guenstigste lieferbare Angebot AUF der
     besten Linie — also mit Updates nach dem Chip und Gesamtnote >= MINV, nie ein Alt-Geraet. */
  /* Die Vergleichszeile hat drei Textstellen: fett, normal, zweite Zeile. Gebaut wird
     sie einmal, danach wandert nur noch Text hinein (siehe pool()-Kommentar oben). */
  var deltaEls = null;
  function buildDelta(el) {
    var b = document.createElement('b'), sp = document.createElement('span');
    b.appendChild(document.createTextNode(''));
    sp.appendChild(document.createTextNode(''));
    while (el.firstChild) { el.removeChild(el.firstChild); }
    el.appendChild(b);
    var mid = document.createTextNode('');
    el.appendChild(mid);
    el.appendChild(sp);
    deltaEls = { b: b.firstChild, mid: mid, sp: sp.firstChild };
  }
  function setDelta(el, fett, mitte, zeile2) {
    if (!deltaEls) { buildDelta(el); }
    setVal(deltaEls.b, fett);
    setVal(deltaEls.mid, mitte);
    setVal(deltaEls.sp, zeile2);
  }
  /* Fuer nackte Textknoten (setText erwartet ein Element). */
  function setVal(node, t) { if (node.nodeValue !== t) { node.nodeValue = t; } }

  /* Ohne Auswahl zeigt die Zeile den Einstieg: das guenstigste lieferbare Angebot AUF der
     besten Linie — also mit Updates nach dem Chip und Gesamtnote >= MINV, nie ein Alt-Geraet. */
  function paintDelta(front) {
    var el = $e('[data-ex-delta]');
    if (!sel || !sel.ok) {
      var base = front.filter(function (p) { return p.pq > 0; })[0] || front[0];
      if (!base) { el.hidden = true; setDelta(el, '', '', ''); return; }
      el.hidden = false;
      setDelta(el,
        'Dein Ausgangspunkt: ' + base.m.name + ' ' + stoLabel(base.st) + ' „' + GLABEL[base.gr] + '" für ' + eur(base.px),
        '',
        'Das günstigste Angebot auf der besten Linie. Gesamtnote ' + Math.round(base.v) + ' von 100, '
          + updLine(base.m) + '. Alles Billigere kann weniger.');
      return;
    }
    var p = sel;
    var cheaper = front.filter(function (q) { return q.px < p.px && q.v >= p.v - 0.01; })
      .sort(function (a, b) { return a.px - b.px; })[0];
    el.hidden = false;
    if (!cheaper) {
      setDelta(el, p.m.name + ' ' + stoLabel(p.st) + ' „' + GLABEL[p.gr] + '"',
        ' liegt selbst auf der besten Linie.',
        'Für weniger Geld bekommst Du nichts Gleichwertiges.');
      return;
    }
    var same = cheaper.m === p.m;
    setDelta(el, eur(p.px - cheaper.px) + ' günstiger',
      ' bekommst Du ' + (same && cheaper.st === p.st ? 'dasselbe Gerät in „' + GLABEL[cheaper.gr] + '".'
        : same ? 'dasselbe Modell mit ' + stoLabel(cheaper.st) + ' in „' + GLABEL[cheaper.gr] + '".'
          : cheaper.m.name + ' ' + stoLabel(cheaper.st) + ' „' + GLABEL[cheaper.gr] + '" — gleiche Gesamtnote.'),
      p.m.name + ' ' + stoLabel(p.st) + ' „' + GLABEL[p.gr] + '" kostet ' + eur(p.px)
        + ', das Angebot auf der Linie ' + eur(cheaper.px) + '.');
  }

  /* ---------- Alle passenden Angebote (Grid unter der Karte) ---------- */
  function gridSorted() {
    var a = lastOk.slice();
    if (gridSort === 'price') { a.sort(function (x, y) { return x.px - y.px; }); }
    else if (gridSort === 'value') { a.sort(function (x, y) { return y.v - x.v; }); }
    else if (gridSort === 'new') { a.sort(function (x, y) { return y.m.release_year - x.m.release_year || x.px - y.px; }); }
    else { a.sort(function (x, y) { return (y.v / y.px) - (x.v / x.px); }); }
    return a;
  }
  function gridCard(p, onFront) {
    var h = (p.act && p.act.h) || p.h, card = cache[h];
    cardPt[h] = p;
    /* Das Band steht immer im Markup und wird per CSS an .is-front gezeigt — sonst
       muesste beim Umsortieren jede Karte neu gebaut werden, nur wegen eines Bandes. */
    return '<article class="tp-ex__gc' + (onFront ? ' is-front' : '') + '" data-i="' + p.i + '">'
      + '<span class="tp-ex__badge">auf der besten Linie</span>'
      + '<div class="tp-ex__buycard" data-ch="' + esc(h) + '">'
      + (card === undefined ? '<div class="tp-ex__skel"></div>' : (card || miniCard(p))) + '</div>'
      + '<button type="button" class="tp-ex__gmeta"'
      + ' aria-label="Alle Preise und Details zu ' + esc(p.m.name + ' ' + stoLabel(p.st) + ', ' + GLABEL[p.gr]) + '">'
      + '<span class="tp-ex__gmt">Gesamtnote <b>' + Math.round(p.v) + '</b> von 100 · ' + stoLabel(p.st) + ' · ' + GLABEL[p.gr] + '</span>'
      + '<span' + (p.exp ? ' class="is-exp"' : '') + '>' + updLine(p.m) + '</span>'
      + '<span class="tp-ex__rmore">Preise &amp; Details</span></button></article>';
  }
  /* Nur was im Blickfeld ist, holt seine echte Produktkarte — 300 Karten auf einmal
     waeren 300 Section-Anfragen fuer nichts. */
  function observeCards() {
    var slots = $e('[data-ex-cards]').querySelectorAll('[data-ch]'), i, h;
    if (!window.IntersectionObserver) {
      for (i = 0; i < slots.length; i++) { fetchCard(slots[i].getAttribute('data-ch')); }
      return;
    }
    if (!IO) {
      IO = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) { return; }
          IO.unobserve(e.target);
          fetchCard(e.target.getAttribute('data-ch'));
        });
      }, { rootMargin: '300px' });
    }
    for (i = 0; i < slots.length; i++) {
      h = slots[i].getAttribute('data-ch');
      if (cache[h] === undefined) { IO.observe(slots[i]); }
    }
  }
  /* Fertige Karten je Punkt und Handle. Beim Umsortieren werden die Knoten verschoben,
     nicht neu geschrieben — sonst laedt jedes Produktbild neu und das Grid blitzt bei
     jedem Regler-Zug. Anderer Handle (andere Farbe gewaehlt) = anderer Schluessel. */
  var gcEl = {};
  function paintGrid() {
    var all = gridSorted(), onFront = {}, i, p, k, el, meta;
    for (i = 0; i < lastFront.length; i++) { onFront[lastFront[i].i] = 1; }
    $e('[data-ex-alln]').textContent = all.length + (all.length === 1 ? ' Angebot' : ' Angebote');
    var chips = $e('[data-ex-sort]').querySelectorAll('[data-s]');
    for (i = 0; i < chips.length; i++) {
      var on = chips[i].getAttribute('data-s') === gridSort;
      chips[i].classList.toggle('is-on', on);
      chips[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    var box = $e('[data-ex-cards]'), show = all.slice(0, gridN);
    if (!show.length) {
      box.innerHTML = '<p class="tp-ex__empty">' + esc(T.grid_empty) + '</p>';
      gcEl = {};
    } else {
      /* ponytail: einfacher Deckel statt Buchfuehrung — die paar hundert Knoten kosten
         nichts, ein voller Katalog in allen Farben soll aber nicht ewig wachsen. */
      if (Object.keys(gcEl).length > 600) { gcEl = {}; }
      var frag = document.createDocumentFragment();
      for (i = 0; i < show.length; i++) {
        p = show[i]; k = p.i + '|' + ((p.act && p.act.h) || p.h);
        el = gcEl[k];
        if (!el) {
          var t = document.createElement('div');
          t.innerHTML = gridCard(p, !!onFront[p.i]);
          el = gcEl[k] = t.firstChild;
        } else {
          el.classList.toggle('is-front', !!onFront[p.i]);
          meta = el.querySelector('.tp-ex__gmeta b');
          if (meta) { meta.textContent = Math.round(p.v); }
        }
        frag.appendChild(el);
      }
      box.textContent = '';
      box.appendChild(frag);
    }
    var more = $e('[data-ex-more]');
    more.hidden = all.length <= gridN;
    more.textContent = Math.min(GRID_STEP, all.length - gridN) + ' weitere anzeigen';
    observeCards();
  }

  /* ---------- Bedienelemente ---------- */
  function chips(label, key, opts) {
    return '<div class="tp-ex__grp"><span class="tp-ex__lbl">' + label + '</span><div class="tp-ex__opts">' + opts.map(function (o) {
      var on = (o.v === Q[key]) || (o.v === null && !Q[key]);
      return '<button type="button" class="tp-ex__chip' + (on ? ' is-on' : '') + '" data-q="' + key
        + '" data-v="' + (o.v === null ? '' : esc(o.v)) + '" aria-pressed="' + (on ? 'true' : 'false') + '">'
        + (o.sw ? swatch(o.sw) : '') + esc(o.l) + '</button>';
    }).join('') + '</div></div>';
  }
  /* Baureihen-Zeile: nur wenn eine Marke gewaehlt ist und sie mehr als eine Baureihe hat.
     Mehrfachauswahl, ODER innerhalb der Zeile. */
  function famChips() {
    var list = (Q.brand && FAMSOF[Q.brand]) || [];
    if (list.length < 2) { return ''; }
    var opts = [{ l: 'Egal', v: '' }].concat(list.map(function (f) { return { l: famLabel(f), v: f }; }));
    return '<div class="tp-ex__grp"><span class="tp-ex__lbl">Baureihe</span><div class="tp-ex__opts">' + opts.map(function (o) {
      var on = o.v ? Q.fams.indexOf(o.v) > -1 : !Q.fams.length;
      return '<button type="button" class="tp-ex__chip' + (on ? ' is-on' : '') + '" data-q="fam" data-v="' + esc(o.v)
        + '" aria-pressed="' + (on ? 'true' : 'false') + '">' + esc(o.l) + '</button>';
    }).join('') + '</div></div>';
  }
  /* Szenarien-Zeile: ein Klick statt sechs. Nochmal klicken stellt die Ausgangslage her. */
  function scenHTML() {
    return '<div class="tp-ex__grp"><span class="tp-ex__lbl">Ich bin …</span><div class="tp-ex__opts">'
      + SCEN.map(function (s) {
        var on = scen === s.id;
        return '<button type="button" class="tp-ex__chip' + (on ? ' is-on' : '') + '" data-scen="' + s.id
          + '" aria-pressed="' + (on ? 'true' : 'false') + '">'
          + '<span class="tp-ex__tick" aria-hidden="true">✓</span><span class="tp-ex__chipt">' + esc(s.l)
          + (s.s2 ? '<small>' + esc(s.s2) + '</small>' : '') + '</span></button>';
      }).join('') + '</div></div>';
  }
  /* Speicher/Zustand/Updates/Farbe sind Feinheiten — wer sie nicht sucht, soll sie
     nicht sehen. Die Zahl am Knopf sagt, wieviele davon gerade vom Standard abweichen. */
  function fineHTML(alwaysOpen) {
    var n = fineCount(Q, DEF);
    var h = chips('Speicher mindestens', 'sto', STOS.map(function (s) { return { l: s ? stoLabel(s) : 'Egal', v: s }; }))
      /* Zustandsart vor Zustand, wie in den Shop-Facetten (condition_type vor condition):
         erst welche Art Gerät, dann welche Mindestqualität. */
      + chips('Zustandsart', 'cond', [
        { l: 'Egal', v: null }, { l: 'Neu', v: 'neu' }, { l: 'Generalüberholt', v: 'refurb' }
      ])
      + chips('Zustand mindestens', 'gr', GRADES.slice().reverse().map(function (g) { return { l: GLABEL[g], v: g }; }))
      + chips('Updates noch', 'upd', UPDS.map(function (u) { return { l: u ? u + ' Jahre' : 'Egal', v: u }; }));
    if (HAS_COLORS) {
      h += chips('Farbe', 'color', [{ l: 'Egal', v: null }].concat(BASES.map(function (b) {
        return { l: COLORNAME[b] || b, v: b, sw: b };
      })));
    }
    return '<details class="tp-ex__fine" data-ex-fine' + (fineOpen || alwaysOpen ? ' open' : '') + '>'
      + '<summary>Feinfilter' + (n ? ' · <b>' + n + '</b>' : '') + '</summary>'
      + '<div class="tp-ex__finein">' + h + '</div></details>';
  }
  /* noFine: auf dem Phone stehen die Feinfilter im Bottom-Sheet, nicht hier. */
  function mustHTML(noFine) {
    var h = scenHTML()
      + chips('Marke', 'brand', [{ l: 'Egal', v: null }].concat(BRANDSIN.map(function (b) {
        return { l: BRANDLABEL[b], v: b };
      })))
      + famChips();
    /* Doppel-Slider „von – bis" nach dem Muster von tp-facet-slider: zwei Regler
       uebereinander, Treffer nur am Knopf, dazwischen die gefuellte Spanne. */
    h += '<div class="tp-ex__grp"><span class="tp-ex__lbl">Preis</span><div class="tp-ex__opts tp-ex__bud">'
      + '<div class="tp-ex__rng" data-ex-rng><div class="tp-ex__rail"></div><div class="tp-ex__fillbar" data-ex-fillbar></div>'
      + '<input type="range" class="tp-ex__rin" data-ex-pmin min="0" max="' + PMAX + '" step="50" value="' + Q.pmin + '" aria-label="Mindestpreis">'
      + '<input type="range" class="tp-ex__rin" data-ex-pmax min="0" max="' + PMAX + '" step="50" value="' + Q.pmax + '" aria-label="Höchstpreis">'
      + '</div><b data-ex-budv>' + budLabel() + '</b></div></div>';
    return noFine ? h : h + fineHTML();
  }
  /* Vier Faelle: nur Obergrenze, nur Untergrenze, beide, keine. */
  function budLabel() {
    var lo = Q.pmin > 0, hi = Q.pmax < PMAX;
    if (lo && hi) { return Q.pmin + ' – ' + Q.pmax + ' €'; }
    if (hi) { return 'bis ' + Q.pmax + ' €'; }
    if (lo) { return 'ab ' + Q.pmin + ' €'; }
    return 'Jeder Preis';
  }
  function syncRange() {
    var bar = $('[data-ex-fillbar]');
    if (!bar) { return; }
    bar.style.left = (100 * Q.pmin / PMAX) + '%';
    bar.style.right = (100 - 100 * Q.pmax / PMAX) + '%';
    setText($('[data-ex-budv]'), budLabel());
  }
  function wHTML() {
    return '<div class="tp-ex__presets">' + PRESETS.map(function (p, i) {
      return '<button type="button" class="tp-ex__chip" data-p="' + i + '">' + esc(p.l) + '</button>';
    }).join('') + '</div><div class="tp-ex__wbar">' + WKEYS.map(function (k) {
      return '<div><label for="tp-ex-w-' + k + '">' + WLABEL[k] + '<b data-ex-wv="' + k + '">' + W[k] + '</b></label>'
        + '<input type="range" id="tp-ex-w-' + k + '" data-w="' + k + '" min="0" max="100" step="5" value="' + W[k] + '"></div>';
    }).join('') + '</div>';
  }
  /* Die zwoelf Knoten des Regler-Panels einmal merken: syncW() laeuft bei jedem Tick. */
  var WEL = null;
  function cacheW() {
    WEL = {};
    WKEYS.forEach(function (k) {
      WEL[k] = { v: root.querySelector('[data-ex-wv="' + k + '"]'), r: root.querySelector('#tp-ex-w-' + k) };
    });
  }
  function syncW() {
    if (!WEL) { cacheW(); }
    WKEYS.forEach(function (k) {
      var e = WEL[k];
      if (!e.v || !e.r) { return; }
      setText(e.v, String(W[k]));
      if (+e.r.value !== W[k]) { e.r.value = W[k]; }
    });
  }
  /* Wieviele Filter weichen von der Ausgangslage ab — die Zahl steht am Leisten-Knopf
     („Filter · 3 aktiv"), damit man im zugeklappten Sheet sieht, dass etwas gesetzt ist. */
  function activeCount() {
    return fineCount(Q, DEF) + (Q.brand ? 1 : 0) + (Q.fams.length ? 1 : 0)
      + ((Q.pmin !== DEF.pmin || Q.pmax !== DEF.pmax) ? 1 : 0);
  }
  /* Die Chip-Zeilen wischen auf dem Phone waagerecht. Statt den aktiven Chip nach vorn
     zu sortieren („2 Jahre | Egal | 4 Jahre" liest sich wie ein Fehler), bleibt die
     natuerliche Reihenfolge und die Zeile scrollt zu ihm hin. Nur die Zeile selbst —
     scrollIntoView wuerde beim ersten Aufbau die ganze Seite nach unten ziehen. */
  function revealChips() {
    var on = root.querySelectorAll('.tp-ex__opts .tp-ex__chip.is-on'), i, c, box;
    for (i = 0; i < on.length; i++) {
      c = on[i]; box = c.parentNode;
      if (box.scrollWidth <= box.clientWidth) { continue; }
      if (c.offsetLeft < box.scrollLeft || c.offsetLeft + c.offsetWidth > box.scrollLeft + box.clientWidth) {
        box.scrollLeft = Math.max(0, c.offsetLeft - 12);
      }
    }
  }
  function syncQ() {
    var ph = phone(), n = activeCount();
    $('[data-ex-must]').innerHTML = mustHTML(ph);
    $('[data-ex-mfine]').innerHTML = ph ? fineHTML(true) : '';
    $('[data-ex-nfilter]').textContent = n ? ' · ' + n + ' aktiv' : '';
    syncRange();
    if (ph) { revealChips(); }
    history.replaceState(null, '', location.pathname + '#' + hashOf(Q));
  }
  /* Phone: das Regler-Panel wandert als Knoten ins Bottom-Sheet (die Handler haengen
     daran), auf dem Desktop zurueck an seinen Platz zwischen Karte und Kaufliste. */
  function layout() {
    /* Ueber die data-Attribute greifen, nicht ueber die Klasse: dieselben Layout-Klassen
       stehen noch einmal im Skeleton. */
    var mw = $('[data-ex-mw]'), panel = $('[data-ex-wrap]').parentNode;
    if (phone()) {
      if (panel.parentNode !== mw) { mw.appendChild(panel); }
      $('[data-ex-wrap]').open = true;
    } else if (panel.parentNode === mw) {
      $('[data-ex-grid]').insertBefore(panel, $('[data-ex-rail]').closest('.tp-ex__railsec'));
      $('[data-ex-wrap]').open = !mob();
    }
  }
  var wasPhone = null;
  function relayout() {
    var ph = phone();
    if (ph !== wasPhone) { wasPhone = ph; layout(); syncQ(); }
    draw();
  }
  /* Nur die Haken an der Szenario-Zeile nachziehen — ohne den Filterblock neu zu bauen
     (waehrend am Preis-Regler gezogen wird, darf der Knopf nicht unter der Maus wegspringen). */
  function syncScen() {
    var bs = root.querySelectorAll('[data-scen]'), i, on;
    for (i = 0; i < bs.length; i++) {
      on = bs[i].getAttribute('data-scen') === scen;
      bs[i].classList.toggle('is-on', on);
      bs[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
  }
  /* Szenario an/aus. Aus heisst: zurueck auf die Ausgangslage, nicht „alles offen". */
  function setScen(id) {
    var s = null, i;
    for (i = 0; i < SCEN.length; i++) { if (SCEN[i].id === id && scen !== id) { s = SCEN[i]; } }
    var r = applyScen(s, DEF, DEFW);
    scen = s ? s.id : null;
    Q = r.q; Q.now = NOW;
    WKEYS.forEach(function (k) { W[k] = r.w[k]; });
    gridN = GRID_STEP;
    if (!s) { PRESET = DEFP; } else if (s.p != null) { PRESET = PRESETS[s.p].l; }
    cause('scenario', scen || 'aus');
    syncW(); syncQ(); paint();
    trk('explorer_preset_selected', { preset: scen || 'aus' });
  }
  /* „Filter lockern": nur die Feinfilter zurueck — Marke, Preis und Regler bleiben,
     sonst wirft der Knopf den ganzen bisherigen Weg weg. */
  function loosen() {
    cause('loosen', '');
    ['sto', 'gr', 'upd', 'color'].forEach(function (k) { Q[k] = DEF[k]; });
    scen = null; gridN = GRID_STEP;
    syncQ(); paint(); trkFilter();
  }

  /* ---------- Tracking (Plan 0077 D10) ----------
     Alles ueber window.TP.track (assets/tp-track.js). Fehlt TP, passiert nichts.
     Regler melden sich entprellt: ein Ereignis je Zug, nicht je Tick. Keine
     personenbezogenen Daten — nur Basename, Konfiguration, Preis, Trefferzahlen.
     Die neuen Typen stehen noch nicht in der Server-Whitelist (Server zuerst),
     bis dahin werden sie hinten still verworfen. */
  function trk(type, props) {
    if (!window.TP || !TP.track) { return; }
    /* Welche Ausgabe der Kunde gesehen hat (Plan 0088, D10). Ohne das Feld
       waere ein Vergleich zweier Ausgaben im Nachhinein nicht aufloesbar. */
    if (DATAV) { props.v = DATAV; }
    TP.track(type, props);
  }
  function onFront(p) {
    return !!(DOTS && DOTS[p.i] && DOTS[p.i].classList.contains('is-front'));
  }
  /* Vor dem Neuzeichnen setzen, danach trkFilter() melden: so kennt auch der
     Leerzustand in paint() den Filter, der ihn erzeugt hat. */
  function cause(filter, value) { trkCause = { filter: filter, value: value }; }
  function trkFilter() {
    if (!trkCause) { return; }
    trk('explorer_filter_changed', {
      filter: trkCause.filter, value: trkCause.value,
      results: lastOk.length, front: lastFront.length
    });
  }
  function trkWeights() {
    clearTimeout(trkWT);
    trkWT = setTimeout(function () {
      var o = { preset: PRESET };
      WKEYS.forEach(function (k) { o[k] = W[k]; });
      trk('explorer_weights_changed', o);
    }, 1500);
  }
  /* Klick auf ein Produkt. Ohne preventDefault — sendBeacon ueberlebt den
     Seitenwechsel (Muster story_product_clicked in tp-story-v2.js). */
  function trkProduct(a, p, source) {
    if (!p) { return; }
    var cp = a.getAttribute('data-cp');
    trk('explorer_product_clicked', {
      basename: p.m.b, storage_gb: p.st, grade: p.gr,
      price_cents: cp ? +cp : p.px, on_front: onFront(p), source: source
    });
  }

  /* ---------- Detail-Sheet ---------- */
  var FICO = {
    cam: '<circle cx="12" cy="13.5" r="4"/><path d="M3 8.5h3.5l2-3h7l2 3H21v11H3z"/>',
    disp: '<rect x="6" y="2.5" width="12" height="19" rx="3"/><path d="M10.5 5.5h3"/>',
    chip: '<rect x="7" y="7" width="10" height="10" rx="2"/><path d="M10 3v4M14 3v4M10 17v4M14 17v4M3 10h4M3 14h4M17 10h4M17 14h4"/>',
    batt: '<rect x="2.5" y="7.5" width="16" height="9" rx="3"/><path d="M21.5 11v2M6 10.5v3M9.5 10.5v3"/>',
    port: '<path d="M9.5 3h5v3.5h-5zM12 6.5v9"/><rect x="7.5" y="15.5" width="9" height="5.5" rx="2"/>',
    shield: '<path d="M12 2.5l8 3v6c0 5-3.4 8.7-8 10-4.6-1.3-8-5-8-10v-6z"/>',
    pen: '<path d="M5 19.5l1.8-5.6L17 3.7l3.3 3.3L10.6 17.7z"/><path d="M15.2 5.6l3.3 3.3"/>',
    ai: '<path d="M12 3l2 5.6L19.5 11 14 13.4 12 19l-2-5.6L4.5 11 10 8.6z"/>',
    '5g': '<path d="M4 14.5a11 11 0 0116 0"/><path d="M7.5 17.5a6.5 6.5 0 019 0"/><circle cx="12" cy="20.5" r="1"/>',
    size: '<path d="M3 8V4h4M21 8V4h-4M3 16v4h4M21 16v4h-4"/>'
  };
  function ico(k) { return '<svg viewBox="0 0 24 24" aria-hidden="true">' + (FICO[k] || FICO.ai) + '</svg>'; }

  function tlHTML(m) {
    /* Die Spanne endet am spaeteren von Update-Ende und heute — sonst klebt „heute"
       bei abgelaufenen Geraeten auf derselben Stelle wie das Update-Ende. */
    var s = secInfo(m), rel = m.release_year, span = Math.max(1, Math.max(m.security_until, NOW) - rel);
    function pos(y) { return Math.max(0, Math.min(100, (y - rel) / span * 100)); }
    var now = pos(NOW);
    var h = '<div class="fill" style="width:' + now + '%"></div>'
      + '<div class="rest ' + s.cls + '" style="left:' + now + '%;right:0"></div>';
    var same = m.os_until === m.security_until;
    [{ y: rel, l: 'Erschienen' },
      same ? null : { y: m.os_until, l: 'OS-Updates bis' },
      { y: NOW, l: 'heute', hot: 1 },
      { y: m.security_until, l: same ? 'System und Sicherheit bis' : 'Sicherheitsupdates bis', hot: 1 }]
      .filter(Boolean).sort(function (a, b) { return a.y - b.y; })
      .forEach(function (mk, i) {
        var p = pos(mk.y);
        h += '<div class="mk' + (mk.hot ? ' hot' : '') + '" style="left:' + p + '%"></div>'
          + '<div class="lb ' + (i % 2 ? 'dn' : 'up') + '" style="left:' + p + '%"><b>' + mk.y + '</b>' + esc(mk.l) + '</div>';
      });
    return '<div class="tp-ex__tlwrap"><div class="tp-ex__tl">' + h + '</div></div>';
  }
  /* Einschaetzung steht als Kachel ZWISCHEN den Features — ein eigener Block darunter
     hat dieselbe Frage zweimal beantwortet („was kann das Ding"). */
  function scaleTile(l, v) {
    var d = '';
    for (var i = 1; i <= 5; i++) { d += '<i class="' + (i <= v ? 'on' : '') + '"></i>'; }
    return '<div class="tp-ex__fk tp-ex__fk--sc"><span>' + l + '</span><span class="tp-ex__dots">' + d + '</span></div>';
  }
  /* Fakten, die schon in einem Feature-Text stehen, fliegen raus — sonst steht unter
     „Snapdragon 680" nochmal die Zeile „Prozessor: 680". */
  function factRows(m) {
    var txt = m.features.map(function (f) { return f[1]; }).join(' ').toLowerCase();
    return Object.keys(m.facts || {}).filter(function (k) {
      return txt.indexOf(String(m.facts[k]).toLowerCase()) < 0;
    });
  }
  function offersOf(b) { return PTS.filter(function (p) { return p.m.b === b; }); }
  /* Preismatrix Speicher x Zustand. Klick waehlt die Zelle — die Farbzeile darunter
     fuehrt dann auf das konkrete Produkt. */
  function mxHTML(m, hSt, hGr) {
    var list = offersOf(m.b), cols = GRADES.slice(), stos = [], byKey = {};
    list.forEach(function (p) {
      if (stos.indexOf(p.st) < 0) { stos.push(p.st); }
      var k = p.st + '|' + p.gr;
      if (!byKey[k] || p.price < byKey[k].price) { byKey[k] = p; }
    });
    stos.sort(function (a, b) { return a - b; });
    var h = '<thead><tr><th>Speicher</th>' + cols.map(function (g) { return '<th>' + GLABEL[g] + '</th>'; }).join('') + '</tr></thead><tbody>';
    stos.forEach(function (st) {
      h += '<tr><td>' + stoLabel(st) + '</td>' + cols.map(function (g) {
        var p = byKey[st + '|' + g];
        if (!p) { return '<td>—</td>'; }
        var cls = (p.qty > 0 ? '' : 'is-out') + (st === hSt && g === hGr ? ' is-hit' : '');
        return '<td class="' + cls.trim() + '"><button type="button" data-cell="' + p.i + '">' + eur(p.price) + '</button></td>';
      }).join('') + '</tr>';
    });
    return '<div class="tp-ex__mxwrap"><table class="tp-ex__mx">' + h + '</tbody></table></div>';
  }
  function colorRowHTML(p) {
    if (!p.cols || !p.cols.length) { return ''; }
    return '<h4>Farben für ' + stoLabel(p.st) + ' „' + GLABEL[p.gr] + '"</h4><ul class="tp-ex__cols">'
      + p.cols.map(function (c) {
        return '<li><a href="/products/' + encodeURIComponent(c.h) + '" data-cp="' + c.price + '">' + swatch(c.base)
          + '<span class="n">' + esc(colorName(c)) + '</span><span class="p">' + eur(c.price) + '</span>'
          + (c.qty > 0 ? '' : '<span class="o">ausverkauft</span>') + '</a></li>';
      }).join('') + '</ul>';
  }
  /* Reihenfolge = Kaufentscheidung: Was ist das, was kostet es, wie komme ich hin.
     Alles Erklaerende („kann es das?", „wie lange?", „Datenblatt") steht darunter. */
  function sheetHTML(p) {
    var m = p.m, facts = factRows(m);
    var a = p.act || { h: p.h, price: p.price };
    var id = cardId[hOf(p)], like = window.TPLikes && id;
    var feats = m.features.slice().sort(function (x, y) { return (y[2] ? 1 : 0) - (x[2] ? 1 : 0); });
    /* Der Griff ist nur auf dem Phone sichtbar (CSS) und schliesst wie das Kreuz. */
    return '<div class="tp-ex__sheet-h"><button type="button" class="tp-ex__grip" data-close aria-label="Schließen"></button><div>'
      + '<h3>' + esc(m.name) + '</h3><p>' + esc(m.brand) + ' · ' + m.release_year + '</p>'
      + '<p class="tp-ex__sheet-p"><b>' + eur(a.price) + '</b>'
      + '<span class="tp-ex__sheet-cfg">Deine Auswahl: ' + stoLabel(p.st) + ' · ' + GLABEL[p.gr] + '</span></p></div>'
      + '<button type="button" class="tp-ex__sheet-x" data-close aria-label="Schließen">✕</button></div>'

      + '<h4>Preis nach Speicher und Zustand</h4>' + mxHTML(m, p.st, p.gr)
      + colorRowHTML(p)

      + '<div class="tp-ex__sheet-f">'
      + (like ? '<button type="button" class="tp-ex__heart" data-heart="' + esc(id) + '" data-h="' + esc(hOf(p))
        + '" aria-label="Merken" aria-pressed="' + (TPLikes.has(id) ? 'true' : 'false') + '">♥</button>' : '')
      + '<a class="tp-ex__pdp" href="/products/' + encodeURIComponent(a.h) + '">Zum Angebot · ' + eur(a.price) + '</a></div>'

      + '<h4>Das kann es</h4><div class="tp-ex__fgrid">'
      + feats.slice(0, 2).map(fkHTML).join('')
      + scaleTile('Kamera', m.cam) + scaleTile('Akku', m.batt) + scaleTile('Leistung', m.chip)
      + feats.slice(2).map(fkHTML).join('') + '</div>'

      + '<h4 class="tp-ex__tlh">Wie lange gibt es Updates?</h4>' + tlHTML(m)
      + (facts.length ? '<details class="tp-ex__facts-d"><summary>Technische Daten</summary>'
        + '<table class="tp-ex__facts"><tbody>' + facts.map(function (k) {
          return '<tr><th>' + esc(k) + '</th><td>' + esc(m.facts[k]) + '</td></tr>';
        }).join('') + '</tbody></table></details>' : '');
  }
  function fkHTML(f) {
    return '<div class="tp-ex__fk' + (f[2] ? ' is-key' : '') + '">' + ico(f[0]) + '<span>' + esc(f[1]) + '</span></div>';
  }
  function renderSheet(p) {
    sheetState = p;
    $('[data-ex-sheet-in]').innerHTML = sheetHTML(p);
  }
  function openSheet(p, source) {
    renderSheet(p);
    if (cache[hOf(p)] === undefined) { fetchCard(hOf(p)); }
    var dlg = $('[data-ex-sheet]');
    /* <dialog>.showModal() haelt den Fokus von sich aus im Sheet (Fokusfalle). */
    if (dlg.showModal) { if (!dlg.open) { dlg.showModal(); } } else { dlg.setAttribute('open', ''); }
    var x = $('[data-ex-sheet-in]').querySelector('[data-close]');
    if (x) { x.focus(); }
    /* Der Typ steht noch nicht in der Server-Whitelist (Plan 0077 D10: Server zuerst) —
       der Aufruf wird heute still verworfen, das ist so gewollt. */
    trk('explorer_offer_opened', {
      basename: p.m.b, storage_gb: p.st, grade: p.gr,
      price_cents: p.px, on_front: onFront(p), source: source || 'dot'
    });
  }

  /* ---------- Start ---------- */
  function init(data) {
    DATA = data;
    DATAV = data.v || '';
    NOW = data.now_year || NOW;
    Q.now = NOW;
    PTS = build(data);
    if (!PTS.length) { return fail(); }

    var famCount = {}, baseSeen = {}, brandSeen = {}, lo = Infinity, hi = 0;
    PTS.forEach(function (p) {
      var bk = brandKey(p.m);
      famCount[p.m.family] = (famCount[p.m.family] || 0) + 1;
      brandSeen[bk] = 1;
      FAMBRAND[p.m.family] = bk;
      if (!FAMSOF[bk]) { FAMSOF[bk] = []; }
      if (FAMSOF[bk].indexOf(p.m.family) < 0) { FAMSOF[bk].push(p.m.family); }
      var prices = p.cols ? p.cols.map(function (c) { return c.price; }) : [p.price];
      prices.forEach(function (c) { if (c < lo) { lo = c; } if (c > hi) { hi = c; } });
      if (p.cols) { p.cols.forEach(function (c) { if (c.base) { baseSeen[c.base] = 1; } }); }
    });
    FAMS = Object.keys(famCount).sort(famSort);
    Object.keys(FAMSOF).forEach(function (b) { FAMSOF[b].sort(famSort); });
    BRANDSIN = BRANDS.filter(function (b) { return brandSeen[b]; });
    BASES = Object.keys(baseSeen).sort();
    HAS_COLORS = BASES.length > 1;
    PMIN = 0;
    PMAX = Math.ceil(hi / 100 / 50) * 50;
    Q.pmax = PMAX;
    Q.pmin = Math.min(+(root.getAttribute('data-pmin') || 0), PMAX - 50);
    Q.upd = +(root.getAttribute('data-upd') || 0);

    var preset = PRESETS[+(root.getAttribute('data-preset') || 0)] || PRESETS[0];
    WKEYS.forEach(function (k) { W[k] = preset.w[k]; DEFW[k] = preset.w[k]; });
    DEF = copyQ(Q);
    PRESET = DEFP = preset.l;

    var q = parseHash(location.hash, FAMS, BASES, PMAX, FAMBRAND);
    if (q) {
      if (q.upd === null) { q.upd = Q.upd; }
      if (q.pmin === null) { q.pmin = Q.pmin; }
      q.now = NOW; Q = q;
    }

    $('[data-ex-w]').innerHTML = wHTML();
    cacheW();
    $('[data-ex-sort]').innerHTML = SORTS.map(function (s) {
      return '<button type="button" class="tp-ex__chip" data-s="' + s.k + '" aria-pressed="false">' + esc(s.l) + '</button>';
    }).join('');
    $('[data-ex-leg]').innerHTML = GRADES.map(function (g) {
      return '<span><i class="' + GCLASS[g] + '"></i>' + GLABEL[g] + '</span>';
    }).join('') + '<span><i class="is-out"></i>ausverkauft</span><span><i class="is-exp"></i>keine Updates mehr</span>'
      + '<span><i class="is-front"></i>auf der besten Linie</span><span>Größerer Punkt = mehr auf Lager</span>';
    /* Mobil ist das Regler-Panel eingeklappt — die Karte soll oben stehen, nicht sechs Regler. */
    $('[data-ex-wrap]').open = !mob();
    if (data.generated_at) {
      var d = new Date(data.generated_at), el = $('[data-ex-stale]');
      el.hidden = false;
      el.textContent = 'Preise und Bestände: Stand '
        + d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
      el.classList.toggle('is-old', (Date.now() - d.getTime()) > 86400000);
    }
    /* Erst jetzt weg mit dem Skeleton: ab hier steht der echte Inhalt in derselben
       Geometrie, es springt nichts. */
    root.classList.remove('is-loading');
    wasPhone = phone();
    layout();
    syncQ();
    draw();
    bind();
    /* Nach draw(), damit lastFront steht: wie viele Punkte auf der besten Linie liegen. */
    trk('explorer_viewed', {
      offers: PTS.length, models: data.models.length, front: lastFront.length,
      preset: PRESET, from_hash: !!q
    });
  }

  /* 503 = StorefrontHub-Job hat noch keinen Snapshot geschrieben (Plan 0077 D6): eigener Text. */
  function fail(notReady) {
    /* Statt des Skeletons steht jetzt der Text — und die feste Leiste unten bleibt weg. */
    root.classList.remove('is-loading');
    root.classList.add('is-err');
    $(notReady ? '[data-ex-wait]' : '[data-ex-err]').hidden = false;
    $('[data-ex-grid]').hidden = true;
    $('[data-ex-all]').hidden = true;
  }

  function bind() {
    /* Derselbe Handler fuer beide Orte: die Muss-Chips auf der Seite und die
       Feinfilter, die auf dem Phone im Bottom-Sheet stehen. */
    var onFilterClick = function (e) {
      /* Klappzustand des Feinfilters merken — der Block wird bei jedem Filterklick neu gebaut. */
      if (e.target.closest('summary')) { fineOpen = !fineOpen; return; }
      var s = e.target.closest('[data-scen]');
      if (s) { setScen(s.getAttribute('data-scen')); return; }
      var b = e.target.closest('[data-q]');
      if (!b) { return; }
      /* Von Hand gedreht: das Szenario stimmt nicht mehr, der Haken muss weg. */
      scen = null;
      var k = b.getAttribute('data-q'), v = b.getAttribute('data-v');
      if (k === 'fam') {
        if (!v) { Q.fams = []; }
        else {
          var at = Q.fams.indexOf(v);
          if (at > -1) { Q.fams.splice(at, 1); } else { Q.fams.push(v); }
        }
      } else if (k === 'brand') {
        Q.brand = v || null;
        Q.fams = [];
      } else {
        Q[k] = (k === 'sto' || k === 'upd') ? +v : (v || null);
      }
      gridN = GRID_STEP;
      /* Chips melden sofort — nur Regler werden entprellt. */
      cause(k, (k === 'fam') ? (Q.fams.join('+') || 'alle') : (v || 'alle'));
      syncQ(); paint(); trkFilter();
    };
    $('[data-ex-must]').addEventListener('click', onFilterClick);
    $('[data-ex-mfine]').addEventListener('click', onFilterClick);
    /* Zwei Regler uebereinander: ohne Zutun faengt immer der obere (Hoechstpreis) den
       Griff ab, sobald beide dicht beieinander stehen. Wer naeher am Zeiger liegt,
       kommt nach oben — geprueft nur beim Schweben, nie waehrend des Ziehens. */
    $('[data-ex-must]').addEventListener('pointermove', function (e) {
      if (e.buttons) { return; }
      var rng = e.target.closest ? e.target.closest('[data-ex-rng]') : null;
      if (!rng) { return; }
      var r = rng.getBoundingClientRect();
      var v = (e.clientX - r.left) / Math.max(1, r.width) * PMAX;
      var near = Math.abs(v - Q.pmin) <= Math.abs(v - Q.pmax);
      if (rng.tpNear === near) { return; }
      rng.tpNear = near;
      var a = rng.querySelector('[data-ex-pmin]'), b = rng.querySelector('[data-ex-pmax]');
      if (a) { a.style.zIndex = near ? 3 : 2; }
      if (b) { b.style.zIndex = near ? 2 : 3; }
    });
    $('[data-ex-must]').addEventListener('input', function (e) {
      var lo = e.target.hasAttribute('data-ex-pmin'), hi = e.target.hasAttribute('data-ex-pmax');
      if (!lo && !hi) { return; }
      /* Treffen sich die Knoepfe, SCHIEBT der gezogene den anderen vor sich her (Muster
         tp-facet-slider). Vorher wurde der gezogene Knopf festgeklemmt — er blieb unter
         dem Finger stehen, und genau das fuehlte sich kaputt an. */
      var other = root.querySelector(lo ? '[data-ex-pmax]' : '[data-ex-pmin]');
      if (lo) {
        Q.pmin = Math.min(+e.target.value, PMAX - 50);
        e.target.value = Q.pmin;
        if (Q.pmax - Q.pmin < 50) { Q.pmax = Q.pmin + 50; if (other) { other.value = Q.pmax; } }
      } else {
        Q.pmax = Math.max(+e.target.value, 50);
        e.target.value = Q.pmax;
        if (Q.pmax - Q.pmin < 50) { Q.pmin = Q.pmax - 50; if (other) { other.value = Q.pmin; } }
      }
      scen = null;
      syncScen();
      gridN = GRID_STEP;
      syncRange();
      history.replaceState(null, '', location.pathname + '#' + hashOf(Q));
      cause(lo ? 'pmin' : 'pmax', Q.pmin + '-' + Q.pmax);
      repaint();
      /* 800 ms nach dem letzten Zug — ein Ereignis je Zug, nicht je Tick. */
      clearTimeout(trkBudT);
      trkBudT = setTimeout(trkFilter, 800);
    });
    $('[data-ex-sort]').addEventListener('click', function (e) {
      var b = e.target.closest('[data-s]');
      if (!b) { return; }
      gridSort = b.getAttribute('data-s');
      gridN = GRID_STEP;
      paintGrid();
    });
    $('[data-ex-more]').addEventListener('click', function () { gridN += GRID_STEP; paintGrid(); });
    $('[data-ex-cards]').addEventListener('click', function (e) {
      var b = e.target.closest('.tp-ex__gmeta');
      if (b) { select(PTS[+b.parentNode.getAttribute('data-i')], 'grid'); }
    });
    $('[data-ex-w]').addEventListener('input', function (e) {
      var k = e.target.getAttribute('data-w');
      if (!k) { return; }
      W[k] = +e.target.value; scen = null; PRESET = null;
      syncScen(); syncW(); repaint(); trkWeights();
    });
    $('[data-ex-w]').addEventListener('click', function (e) {
      var b = e.target.closest('[data-p]');
      if (!b) { return; }
      var p = PRESETS[+b.getAttribute('data-p')];
      WKEYS.forEach(function (k) { W[k] = p.w[k]; });
      scen = null; PRESET = p.l; syncScen(); syncW(); paint();
      trk('explorer_preset_selected', { preset: p.l });
    });

    /* ---- Rail: Karte und Punkt zeigen aufeinander ---- */
    var rail = $('[data-ex-rail]');
    rail.addEventListener('mouseover', function (e) {
      var c = e.target.closest('.tp-ex__rc');
      if (c) { hot(+c.getAttribute('data-i'), true, false); }
    });
    rail.addEventListener('mouseout', function (e) {
      var c = e.target.closest('.tp-ex__rc');
      if (c && !c.contains(e.relatedTarget)) { hot(+c.getAttribute('data-i'), false, false); }
    });
    rail.addEventListener('focusin', function (e) {
      var c = e.target.closest('.tp-ex__rc');
      if (c) { hot(+c.getAttribute('data-i'), true, true); }
    });
    rail.addEventListener('focusout', function (e) {
      var c = e.target.closest('.tp-ex__rc');
      if (c) { hot(+c.getAttribute('data-i'), false, false); }
    });
    /* Die Karte selbst ist jetzt die echte Produktkarte und fuehrt auf das Produkt
       (ein Link, kein Knopf). Das Sheet oeffnet der Fuss mit Ring und Update-Zeile. */
    rail.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ex-open-i]');
      if (b) { select(PTS[+b.getAttribute('data-ex-open-i')], 'list'); }
    });
    root.addEventListener('click', function (e) {
      var a = e.target.closest('[data-ex-arw]');
      if (a) {
        rail.scrollBy({ left: +a.getAttribute('data-ex-arw') * Math.max(220, rail.clientWidth - 120), behavior: 'smooth' });
        return;
      }
      if (e.target.closest('[data-ex-loose]')) { loosen(); }
    });
    /* Jeder Weg auf eine Produktseite — Sheet, Farbzeile, Kaufliste, Grid. Eine Stelle
       statt vier Handler; das Ziel steht im href, der Punkt am naechsten data-i. */
    root.addEventListener('click', function (e) {
      var a = e.target.closest('a[href]');
      if (!a || a.getAttribute('href').indexOf('/products/') !== 0) { return; }
      var box = a.closest('[data-i]');
      var source = a.closest('[data-ex-sheet]')
        ? (a.closest('.tp-ex__cols') ? 'color' : 'sheet')
        : (a.closest('[data-ex-rail]') ? 'list' : 'grid');
      trkProduct(a, box ? PTS[+box.getAttribute('data-i')] : sheetState, source);
    });
    /* Info-Punkt an der senkrechten Achse: Klick haelt das Popover offen, Hover zeigt
       es fluechtig (CSS). Ein Klick irgendwo sonst macht es wieder zu. */
    var info = $('[data-ex-info]');
    info.addEventListener('click', function (e) {
      e.stopPropagation();
      var on = info.getAttribute('aria-expanded') !== 'true';
      info.setAttribute('aria-expanded', on ? 'true' : 'false');
      info.parentNode.classList.toggle('is-open', on);
    });
    document.addEventListener('click', function () {
      info.setAttribute('aria-expanded', 'false');
      info.parentNode.classList.remove('is-open');
    });

    var card = $('[data-ex-card]'), tip = $('[data-ex-tip]');
    card.addEventListener('mouseover', function (e) {
      var line = e.target.closest('[data-f]'), i;
      if (line) {
        var fam = line.getAttribute('data-f');
        root.querySelector('[data-ex-dots]').classList.add('is-dim');
        for (i = 0; i < PTS.length; i++) { DOTS[i].classList.toggle('is-fam', PTS[i].m.family === fam); }
        if (line.hasAttribute('data-a')) { showStepTip(line, tip, card, PTS[+line.getAttribute('data-a')], PTS[+line.getAttribute('data-b')]); }
        return;
      }
      var el = e.target.closest('.tp-ex__pt');
      if (!el) { tip.style.opacity = 0; return; }
      showTip(el, tip, card);
      /* Punkt beruehrt: die Rail faehrt zur passenden Karte und hebt sie hervor. */
      hot(+el.getAttribute('data-i'), true, true);
    });
    card.addEventListener('mouseout', function (e) {
      if (e.target.closest('[data-f]')) {
        root.querySelector('[data-ex-dots]').classList.remove('is-dim');
        for (var i = 0; i < PTS.length; i++) { DOTS[i].classList.remove('is-fam'); }
      }
      var el = e.target.closest('.tp-ex__pt');
      if (el) { hot(+el.getAttribute('data-i'), false, false); }
      if (!card.contains(e.relatedTarget)) { tip.style.opacity = 0; }
    });
    card.addEventListener('focusin', function (e) {
      var el = e.target.closest('.tp-ex__pt');
      if (el) { showTip(el, tip, card); }
    });
    card.addEventListener('click', function (e) {
      var el = e.target.closest('.tp-ex__pt') || nearDot(e);
      if (!el) { return; }
      select(PTS[+el.getAttribute('data-i')], 'dot');
    });
    card.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') { return; }
      var el = e.target.closest('.tp-ex__pt');
      if (!el) { return; }
      e.preventDefault();
      select(PTS[+el.getAttribute('data-i')], 'dot');
    });

    var dlg = $('[data-ex-sheet]');
    dlg.addEventListener('click', function (e) {
      if (e.target.closest('[data-close]') || e.target === dlg) { dlg.close ? dlg.close() : dlg.removeAttribute('open'); return; }
      var cell = e.target.closest('[data-cell]');
      if (cell) { renderSheet(PTS[+cell.getAttribute('data-cell')]); return; }
      var heart = e.target.closest('[data-heart]');
      if (heart) {
        heart.setAttribute('aria-pressed', heart.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        TPLikes.toggle(heart.getAttribute('data-heart'), heart.getAttribute('data-h'));
      }
    });
    dlg.addEventListener('close', function () { sheetState = null; });

    /* ---- Phone: Ansicht umschalten und Filter-Sheet ---- */
    var vsw = $('[data-ex-vsw]');
    vsw.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ex-view]'), bs = vsw.querySelectorAll('[data-ex-view]'), i;
      if (!b) { return; }
      var list = b.getAttribute('data-ex-view') === 'liste';
      root.classList.toggle('is-list', list);
      for (i = 0; i < bs.length; i++) { bs[i].setAttribute('aria-pressed', bs[i] === b ? 'true' : 'false'); }
      /* Versteckt war die Karte 0 px breit — die Geometrie muss neu gemessen werden. */
      if (!list) { draw(); }
    });
    var msheet = $('[data-ex-msheet]');
    $('[data-ex-bbar]').addEventListener('click', function (e) {
      var b = e.target.closest('[data-ex-open]');
      if (!b) { return; }
      if (msheet.showModal) { if (!msheet.open) { msheet.showModal(); } } else { msheet.setAttribute('open', ''); }
      var to = b.getAttribute('data-ex-open') === 'weights' ? $('[data-ex-mw]') : $('[data-ex-mfine]');
      msheet.scrollTop = 0;
      if (to && to.scrollIntoView) { to.scrollIntoView({ block: 'start' }); }
    });
    msheet.addEventListener('click', function (e) {
      if (e.target !== msheet && !e.target.closest('[data-mclose]')) { return; }
      if (msheet.close) { msheet.close(); } else { msheet.removeAttribute('open'); }
    });

    var mq = window.matchMedia('(max-width:749px)');
    if (mq.addEventListener) { mq.addEventListener('change', relayout); } else { mq.addListener(relayout); }
    var t = null;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(relayout, 200); });
  }

  /* Der Tooltip wird EINMAL gebaut und danach nur noch beschrieben. Beim Fahren ueber
     die Punkte feuert mouseover im Dutzend; ein innerHTML kostet hier jedes Mal 50 ms
     (siehe pool()) — genau das liess den Tooltip hinterherhinken. */
  var tipEls = null;
  function buildTip(tip) {
    var mk = function (tag, cls) {
      var e = document.createElement(tag);
      if (cls) { e.className = cls; }
      e.appendChild(document.createTextNode(''));
      tip.appendChild(e);
      return e;
    };
    while (tip.firstChild) { tip.removeChild(tip.firstChild); }
    var a = mk('b'), mid = document.createTextNode('');
    tip.appendChild(mid);
    var pr = mk('b', 'i'), line = mk('span'), sws = document.createElement('span');
    sws.className = 'tp-ex__sws';
    var sw = [], i;
    for (i = 0; i < 6; i++) {
      var ic = document.createElement('i');
      ic.setAttribute('aria-hidden', 'true');
      sws.appendChild(ic);
      sw.push(ic);
    }
    var cnt = document.createElement('span');
    cnt.className = 'tp-ex__sws-n';
    cnt.appendChild(document.createTextNode(''));
    sws.appendChild(cnt);
    tip.appendChild(sws);
    tipEls = { a: a, mid: mid, pr: pr, line: line, sws: sws, sw: sw, cnt: cnt };
  }
  /* fett | Text dahinter | fetter Preis | zweite Zeile | Farbtupfer */
  function fillTip(tip, fett, mitte, preis, zeile, zeileKlasse, p) {
    if (!tipEls) { buildTip(tip); }
    setText(tipEls.a, fett);
    setVal(tipEls.mid, mitte);
    setText(tipEls.pr, preis);
    tipEls.pr.style.display = preis ? '' : 'none';
    setText(tipEls.line, zeile);
    tipEls.line.className = zeileKlasse || '';
    var cols = (p && p.cols) || null, seen = {}, out = [], i;
    for (i = 0; cols && i < cols.length && out.length < 6; i++) {
      var base = cols[i].base || 'gray';
      if (seen[base]) { continue; }
      seen[base] = 1;
      out.push({ base: base, name: colorName(cols[i]) });
    }
    for (i = 0; i < tipEls.sw.length; i++) {
      var on = i < out.length;
      tipEls.sw[i].style.display = on ? '' : 'none';
      if (!on) { continue; }
      tipEls.sw[i].className = 'tp-ex__sw tp-ex__sw--' + out[i].base;
      tipEls.sw[i].title = out[i].name;
    }
    setText(tipEls.cnt, cols ? cols.length + (cols.length === 1 ? ' Farbe' : ' Farben') : '');
    tipEls.sws.style.display = cols ? '' : 'none';
  }

  /* „iPhone 13 → 14 · 80 € mehr für 9 Punkte mehr Leistung" — was der Schritt zur
     naechsten Generation kostet. */
  function showStepTip(el, tip, card, a, b) {
    var dp = b.px - a.px, dv = Math.round(b.v - a.v);
    fillTip(tip, famLabel(a.m.family) + ' ' + shortName(a.m) + ' → ' + shortName(b.m),
      ' · ' + eur(Math.abs(dp)) + (dp >= 0 ? ' mehr' : ' weniger')
        + ' für ' + Math.abs(dv) + ' Punkte ' + (dv >= 0 ? 'mehr' : 'weniger') + ' Gesamtnote',
      '', a.m.name + ' ' + eur(a.px) + ' · ' + b.m.name + ' ' + eur(b.px), 'l', null);
    placeTip(el, tip, card);
  }
  function showTip(el, tip, card) {
    var p = PTS[+el.getAttribute('data-i')];
    fillTip(tip, p.m.name, ' · ' + stoLabel(p.st) + ' · ' + GLABEL[p.gr] + ' — ', eur(p.px),
      ' · Gesamtnote ' + Math.round(p.v) + ' von 100 · '
        + (p.pq > 0 ? 'noch ' + p.pq + ' auf Lager' : 'ausverkauft')
        + (p.exp ? ' · keine Updates mehr' : ''), '', p);
    placeTip(el, tip, card);
  }
  function placeTip(el, tip, card) {
    tip.style.opacity = 1;
    var b = el.getBoundingClientRect(), r = card.getBoundingClientRect(), w = tip.offsetWidth;
    tip.style.left = Math.max(4, Math.min(r.width - w - 4, b.left - r.left + b.width / 2 - w / 2)) + 'px';
    tip.style.top = Math.max(4, b.top - r.top - tip.offsetHeight - 8) + 'px';
  }

  /* Der Daumen trifft den 8-px-Kreis nicht. Auf dem Phone gewinnt deshalb der naechste
     sichtbare Punkt im Umkreis von 24 CSS-Pixeln um den Tipp — nur wenn kein Punkt
     direkt getroffen wurde. */
  function nearDot(e) {
    if (!GEO || !GEO.ph || !DOTS) { return null; }
    var svg = $('[data-ex-plot]').querySelector('svg');
    if (!svg) { return null; }
    var r = svg.getBoundingClientRect(), k = r.width / GEO.w, best = null, bd = 24, i;
    for (i = 0; i < PTS.length; i++) {
      var p = PTS[i];
      if (!shown(p)) { continue; }
      var dx = r.left + X(p.px) * k - e.clientX, dy = r.top + Y(p.v) * k - e.clientY;
      var d = Math.sqrt(dx * dx + dy * dy);
      if (d < bd) { bd = d; best = DOTS[i]; }
    }
    return best;
  }

  function select(p, source) {
    sel = p;
    for (var i = 0; i < DOTS.length; i++) { DOTS[i].classList.remove('is-sel'); }
    DOTS[p.i].classList.add('is-sel');
    paintDelta(lastFront);
    openSheet(p, source);
  }

  fetch(root.getAttribute('data-url'), { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
    .then(function (d) { if (d && d.offers && d.models) { init(d); } else { fail(false); } })
    .catch(function (status) { fail(status === 503); });
})();
